{
  "invoice": {
    "title": "Factures",
    "subtitle": "Liste des factures inter-marchands",
    "columns": {
      "number": "Numéro",
      "merchant": "Marchand",
      "issuedAt": "Émis le",
      "dueAt": "Échéance",
      "amount": "Montant",
      "status": "Statut",
      "actions": "Actions"
    },
    "actions": {
      "view": "Voir",
      "download": "Télécharger PDF",
      "resendEmail": "Renvoyer l'email",
      "bulkResend": "Renvoi groupé",
      "markPaid": "Marquer payé",
      "creditNote": "Émettre une note de crédit",
      "debitNote": "Émettre une note de débit",
      "reversePayment": "Annuler le paiement",
      "manualGenerate": "Générer manuellement"
    },
    "status": {
      "draft": "Brouillon",
      "issued": "Émise",
      "partiallyPaid": "Partiellement payée",
      "paid": "Payée",
      "overdue": "En retard",
      "cancelled": "Annulée"
    },
    "filters": {
      "merchant": "Marchand",
      "status": "Statut",
      "periodFrom": "Période du",
      "periodTo": "Période au",
      "overdueOnly": "En retard uniquement",
      "search": "Rechercher par numéro",
      "searchLabel": "Rechercher",
      "searchPlaceholder": "Rechercher par n° de facture, marchand…",
      "searchAria": "Rechercher des factures",
      "statusAria": "Filtre de statut",
      "allStatuses": "Tous les statuts",
      "merchantPlaceholder": "Tous les marchands",
      "periodFromAria": "Début de période",
      "periodToAria": "Fin de période",
      "overdueChipAria": "{{count}} factures en retard",
      "clearFilters": "Effacer les filtres"
    },
    "empty": {
      "title": "Aucune facture trouvée",
      "body": "Ajustez vos filtres ou attendez le prochain cycle de facturation."
    },
    "errors": {
      "loadFailed": "Échec du chargement des factures",
      "resendFailed": "Échec du renvoi de l'email",
      "amountMismatch": "Le montant du paiement ne correspond pas au total"
    },
    "confirm": {
      "bulkResend": "Renvoyer l'email pour {{count}} facture(s) ?",
      "markPaid": "Confirmer que cette facture a été entièrement payée ?",
      "reverse": "Annuler le paiement ? Cette action est journalisée."
    },
    "detail": {
      "paymentHistory": "Historique des paiements",
      "versions": "Historique des versions",
      "linkedDocs": "Documents liés",
      "downloadPdf": "Télécharger PDF",
      "statusLabels": {
        "DRAFT": "Brouillon",
        "SENT": "Envoyée · En attente de paiement",
        "PARTIAL": "Partielle",
        "PAID": "Payée",
        "OVERDUE": "En retard",
        "VOID": "Annulée",
        "PENDING_APPROVAL": "En attente d'approbation"
      },
      "missingId": "Identifiant de facture manquant.",
      "backToInvoices": "Retour aux factures",
      "heading": "Facture {{number}}",
      "merchantPrefix": "Marchand :",
      "cyclePrefix": "Cycle :",
      "createdPrefix": "Créée le",
      "loading": "Chargement…",
      "unavailable": "Détail indisponible.",
      "resendDraftTooltip": "Impossible de renvoyer une facture DRAFT — générez-la d'abord",
      "cnDraftTooltip": "La facture doit être SENT ou au-delà pour émettre une note de crédit",
      "dnNotImplementedTitle": "Note de débit non disponible",
      "dnNotImplementedDesc": "L'endpoint backend /admin/invoices/:id/debit-notes n'est pas encore disponible. Utilisez une note de crédit ou contactez un admin.",
      "dnNotImplementedTooltip": "Note de débit : endpoint backend non disponible",
      "markPaidDraftTooltip": "La facture doit être SENT ou au-delà pour la marquer payée",
      "lineItems": "Lignes",
      "lineItemsCols": {
        "order": "Cmd #",
        "chargeType": "Type de charge",
        "net": "Net",
        "taxRate": "Taux",
        "tax": "Taxe",
        "gross": "Brut"
      },
      "noLineItems": "Aucune ligne.",
      "taxLinesTitle": "Lignes de taxe (par juridiction)",
      "taxable": "imposable",
      "taxWord": "taxe",
      "reverseCharge": "autoliquidation",
      "subtotal": "Sous-total",
      "creditApplied": "Crédit appliqué",
      "taxLabel": "Taxe",
      "totalDue": "Total dû",
      "status": "Statut",
      "duePrefix": "Échéance :",
      "netTermsPrefix": "Conditions :",
      "remainingPrefix": "Restant :",
      "timeline": "Chronologie",
      "timelineLabels": {
        "created": "Créée",
        "sent": "Envoyée",
        "paid": "Payée"
      },
      "timelineBy": {
        "system": "système",
        "admin": "admin",
        "pending": "en attente"
      },
      "auditMetadata": "Métadonnées d'audit",
      "auditFields": {
        "invoiceId": "ID facture",
        "merchantId": "ID marchand",
        "version": "Version",
        "created": "Créée",
        "updated": "Mise à jour"
      },
      "chargeTypeLabels": {
        "ORDER_CHARGE": "Commande",
        "SURCHARGE_CHARGE": "Surcharge",
        "EMBROIDERY_CHARGE": "Broderie"
      },
      "reverseConfirm": "Annuler le paiement {{reference}} de {{amount}} ?",
      "markPaidModal": {
        "title": "Marquer payé",
        "amountLabel": "Montant (USD)",
        "amountPositive": "Le montant doit être supérieur à 0",
        "referenceRequired": "Référence requise",
        "remaining": "Restant : {{amount}}",
        "gatewayLabel": "Passerelle",
        "referenceLabel": "Référence",
        "referencePlaceholder": "ex. SWIFT-DBS-2026-04-29-001",
        "proofLabel": "URL du justificatif (optionnel)",
        "proofPlaceholder": "https://…/proof.pdf",
        "notesLabel": "Notes (optionnel)",
        "overThresholdNotice": "Approbation admin requise — le montant dépasse le seuil comptable de 10 000 $.",
        "cancel": "Annuler",
        "submitting": "Envoi…",
        "submit": "Envoyer",
        "adminApprovalTitle": "Approbation admin requise",
        "adminApprovalDesc": "Le montant dépasse 10 000 $ — seul un admin peut le marquer payé.",
        "adminApprovalTooltip": "Approbation admin requise"
      },
      "toast": {
        "loadFailed": "Échec du chargement de la facture",
        "markPaidFailed": "Échec du marquage payé",
        "paymentRecorded": "Paiement enregistré",
        "paymentRecordedDesc": "En attente d'approbation. Approuvez depuis la liste de l'historique des paiements.",
        "approveFailed": "Échec de l'approbation",
        "paymentApproved": "Paiement approuvé",
        "paymentApprovedDesc": "Statut de la facture mis à jour en PAID/PARTIAL.",
        "rejectReasonRequired": "Motif de rejet requis",
        "rejectReasonMin": "Minimum 3 caractères.",
        "rejectFailed": "Échec du rejet",
        "paymentRejected": "Paiement rejeté",
        "paymentRejectedDesc": "Le marchand a été notifié avec le motif.",
        "reverseFailed": "Échec de l'annulation",
        "paymentReversed": "Paiement annulé",
        "paymentReversedDesc": "Solde de la facture restauré ; écriture comptable inversée.",
        "resendFailed": "Échec du renvoi",
        "emailQueued": "Email mis en file",
        "emailQueuedDesc": "Email de facture renvoyé au contact de facturation du marchand.",
        "networkError": "Erreur réseau - vérifiez la connexion",
        "unknown": "Inconnu"
      },
      "approveModal": {
        "title": "Examiner le paiement soumis",
        "amount": "Montant",
        "gateway": "Passerelle",
        "reference": "Référence",
        "submitted": "Soumis le",
        "notesPrefix": "Notes :",
        "proofAttachment": "Justificatif joint",
        "proofAlt": "Justificatif de paiement",
        "proofPdfTitle": "Justificatif de paiement PDF",
        "openProof": "Ouvrir le justificatif ↗",
        "noProof": "Aucun justificatif joint.",
        "rejectReasonLabel": "Motif de rejet",
        "rejectReasonPlaceholder": "Min. 3 caractères — envoyé au marchand par email",
        "reject": "Rejeter",
        "confirmReject": "Confirmer le rejet",
        "rejecting": "Rejet…",
        "approve": "Approuver",
        "approving": "Approbation…"
      }
    },
    "list": {
      "subtitle": "Gérez les factures des marchands sur toute la plateforme. Les factures sont immuables — émettez une note de crédit ou de débit au lieu de les modifier.",
      "generateManual": "+ Générer manuellement",
      "columns": {
        "invoiceNumber": "N° de facture",
        "type": "Type",
        "merchant": "Marchand",
        "period": "Période",
        "amount": "Montant",
        "paymentGateway": "Passerelle de paiement",
        "gatewayFee": "Frais de passerelle",
        "status": "Statut",
        "due": "Échéance",
        "actions": "Actions"
      },
      "selectAllAria": "Tout sélectionner sur la page",
      "selectRowAria": "Sélectionner la facture {{number}}",
      "loading": "Chargement des factures…",
      "emptyFiltered": "Aucune facture ne correspond aux filtres actuels",
      "bulk": {
        "selected": "{{count}} factures sélectionnées",
        "eligibleNote": "({{count}} éligibles au renvoi — DRAFT / VOID exclus)",
        "resend": "Renvoyer l'email ({{count}})",
        "sending": "Envoi…",
        "clear": "Effacer",
        "noPermission": "Vous n'avez pas la permission de renvoyer les emails de facture.",
        "selectEligible": "Sélectionnez au moins une facture SENT / PARTIAL / OVERDUE / PAID"
      },
      "toast": {
        "oneQueued": "1 email mis en file",
        "manyQueued": "{{count}} emails mis en file",
        "queuedDesc": "Demandes de renvoi de facture envoyées avec succès.",
        "partialQueued": "{{queued}} sur {{total}} emails mis en file",
        "partialDesc": "{{count}} ignorés ({{reason}}).",
        "skippedTitle": "Renvoi ignoré",
        "skippedDescFallback": "Aucun email mis en file.",
        "resendFailed": "Échec du renvoi"
      },
      "prefixTooltip": "Préfixe de numérotation : {{prefix}}"
    },
    "typeLabels": {
      "Payment": "Paiement",
      "Refund": "Remboursement",
      "Surcharge": "Surcharge"
    },
    "statusLabels": {
      "DRAFT": "Brouillon",
      "SENT": "Envoyée",
      "PARTIAL": "Partielle",
      "PAID": "Payée",
      "OVERDUE": "En retard",
      "VOID": "Annulée"
    },
    "paymentStatusLabels": {
      "PENDING_APPROVAL": "En attente d'approbation",
      "APPROVED": "Approuvé",
      "REJECTED": "Rejeté",
      "REVERSED": "Annulé"
    },
    "pdfPreview": {
      "unavailable": "Aperçu PDF indisponible.",
      "draftHint": "Les factures DRAFT ne génèrent un PDF qu'après le passage à SENT.",
      "label": "Aperçu PDF de la facture",
      "openNewTab": "Ouvrir dans un nouvel onglet ↗",
      "iframeTitle": "Aperçu PDF de la facture {{number}}"
    },
    "paymentHistory": {
      "loading": "Chargement de l'historique des paiements…",
      "empty": "Aucun paiement enregistré.",
      "reversedBadge": "Annulé",
      "refPrefix": "Réf. :",
      "submittedPrefix": "Soumis :",
      "approvedPrefix": "Approuvé :",
      "reversedPrefix": "Annulé :",
      "rejectedPrefix": "Rejeté :",
      "reverseReasonPrefix": "Motif d'annulation :",
      "review": "Examiner",
      "reverse": "Annuler"
    },
    "markPaidModal": {
      "aria": "Marquer payé — Facture {{number}}",
      "title": "Marquer payé — Facture {{number}}",
      "subtitle": "Enregistrez un paiement pour cette facture. L'action est consignée dans le journal d'audit.",
      "outstanding": "Restant (outstanding)",
      "version": "Version",
      "amountLabel": "Montant (USD)",
      "amountHelp": "Par défaut = solde restant. Saisissez un montant inférieur pour un paiement partiel (le statut devient PARTIAL).",
      "amountPositive": "Le montant doit être supérieur à 0.",
      "gatewayLabel": "Passerelle de paiement",
      "referenceLabel": "Référence",
      "referencePlaceholder": "ex. WIRE-20260517-1234",
      "referenceHelp": "Requis — id wire/SWIFT/transaction pour rapprochement ultérieur.",
      "referenceMin": "Référence requise (minimum {{min}} caractères).",
      "referenceMax": "Référence trop longue (maximum {{max}} caractères).",
      "notesLabel": "Notes (optionnel)",
      "notesPlaceholder": "ex. Confirmé sur le portail bancaire.",
      "thresholdBlock": "Le montant dépasse la limite comptable de 10 000 $. La permission invoice:mark_paid:unlimited (Admin/Super Admin) est requise — demandez à un admin d'approuver ou réduisez le montant.",
      "thresholdTooltip": "Le montant dépasse 10 000 $ — permission invoice:mark_paid:unlimited (Admin) requise.",
      "thresholdWarnTitle": "Permission admin requise pour approuver ce montant",
      "thresholdWarnDesc": "Le montant dépasse 10 000 $ — permission invoice:mark_paid:unlimited (Admin/Super Admin) requise.",
      "cancel": "Annuler",
      "submitting": "Traitement…",
      "submit": "Marquer payé",
      "toast": {
        "success": "Facture marquée comme payée",
        "successDesc": "Statut de paiement de la facture {{number}} mis à jour.",
        "conflictTitle": "Facture mise à jour par quelqu'un d'autre",
        "conflictDesc": "La facture a été mise à jour par un autre utilisateur — actualisez et réessayez.",
        "thresholdError": "Le montant dépasse la limite autorisée — permission invoice:mark_paid:unlimited requise.",
        "voidTitle": "Facture VOID",
        "voidDesc": "La facture est VOID — elle ne peut pas être payée.",
        "failTitle": "Impossible de marquer payé",
        "networkTitle": "Erreur réseau",
        "networkDesc": "Vérifiez votre connexion et réessayez."
      }
    },
    "reverseModal": {
      "aria": "Annuler le paiement",
      "title": "Annuler le paiement",
      "subtitle": "Cette action annule le paiement, recalcule le statut de la facture et écrit un journal d'audit. À utiliser uniquement en cas de rejet bancaire ou de saisie erronée.",
      "amount": "Montant",
      "gateway": "Passerelle",
      "reference": "Référence",
      "createdAt": "Créé le",
      "approvedBy": "Approuvé par",
      "submittedBy": "Soumis par",
      "reasonLabel": "Motif d'annulation",
      "reasonPlaceholder": "ex. La banque a signalé le retour du virement en raison d'un code SWIFT BIC incorrect — annuler et demander une nouvelle soumission.",
      "reasonMin": "Le motif d'annulation nécessite au moins {{min}} caractères (actuellement {{count}}).",
      "reasonMax": "Le motif d'annulation peut comporter au plus {{max}} caractères.",
      "reasonRemaining": "{{count}} caractères supplémentaires nécessaires.",
      "reasonCount": "{{count}}/{{max}}",
      "cancel": "Annuler",
      "submitting": "Annulation…",
      "submit": "Annuler le paiement",
      "toast": {
        "success": "Paiement annulé",
        "successDesc": "Le paiement {{reference}} a été annulé. Le statut de la facture sera recalculé automatiquement.",
        "forbiddenTitle": "Pas de permission d'annulation",
        "forbiddenDesc": "Vous avez besoin de la permission invoice:payment_reverse pour cette action.",
        "notFoundTitle": "Paiement introuvable",
        "notFoundDesc": "Le paiement a été supprimé ou modifié — la liste sera actualisée.",
        "alreadyTitle": "Paiement déjà annulé",
        "alreadyDesc": "Quelqu'un d'autre a déjà annulé ce paiement — la liste sera actualisée.",
        "reasonTooShort": "Le motif d'annulation nécessite au moins {{min}} caractères.",
        "failTitle": "Échec de l'annulation",
        "failDesc": "Veuillez réessayer.",
        "networkTitle": "Erreur réseau",
        "networkDesc": "Vérifiez votre connexion et réessayez."
      }
    },
    "creditNoteModal": {
      "aria": "Émettre une note de crédit",
      "title": "Émettre une note de crédit",
      "subtitle": "Créez CN-YYYYMM-XXXXX liée à la facture{{label}}. Le backend génère le PDF et le journal d'audit.",
      "lineItemsLabel": "Lignes (sélectionnez les lignes concernées — optionnel)",
      "noLineItems": "Lignes de facture non chargées. La note de crédit s'appliquera à toute la facture si aucune ligne n'est sélectionnée.",
      "selectedSummary": "{{selected}}/{{total}} lignes sélectionnées · {{amount}}",
      "amountInvalid": "Saisissez un montant valide (supérieur à 0).",
      "reasonMin": "Le motif nécessite au moins {{min}} caractères.",
      "amountExceeds": "Le montant de la note de crédit dépasse le total de la facture. Saisissez un montant inférieur ou égal au total.",
      "cancel": "Annuler",
      "submitting": "Émission…",
      "submit": "Émettre une note de crédit",
      "toast": {
        "success": "Note de crédit {{number}} émise",
        "successDesc": "{{amount}} a été enregistré. PDF et journal d'audit créés.",
        "invalidTitle": "Données invalides",
        "notFoundTitle": "Facture introuvable",
        "failTitle": "Impossible d'émettre la note de crédit",
        "networkTitle": "Erreur réseau",
        "networkDesc": "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez."
      }
    },
    "debitNoteModal": {
      "aria": "Émettre une note de débit",
      "title": "Émettre une note de débit",
      "subtitle": "Créez DN-YYYYMM-XXXXX liée à la facture{{label}}. Le backend génère le PDF et le journal d'audit.",
      "descLabel": "Description de la ligne de débit",
      "descPlaceholder": "Ex. « Surcharge de livraison express pour OR ». Au moins {{min}} caractères.",
      "descHint": "{{count}}/{{max}} caractères (minimum {{min}}).",
      "descError": "La description de la ligne de débit doit comporter {{min}}-{{max}} caractères.",
      "referenceLineItems": "Lignes de la facture d'origine (référence seulement)",
      "amountInvalid": "Saisissez un montant valide (supérieur à 0).",
      "reasonMin": "Le motif nécessite au moins {{min}} caractères.",
      "cancel": "Annuler",
      "submitting": "Émission…",
      "submit": "Émettre une note de débit",
      "toast": {
        "success": "Note de débit {{number}} émise",
        "successDesc": "{{amount}} a été enregistré. PDF et journal d'audit créés.",
        "invalidTitle": "Données invalides",
        "notFoundTitle": "Facture introuvable",
        "failTitle": "Impossible d'émettre la note de débit",
        "networkTitle": "Erreur réseau",
        "networkDesc": "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez."
      }
    },
    "noteForm": {
      "amountLabel": "Montant (USD)",
      "amountPlaceholder": "0.00",
      "amountHint": "Montants en USD. Saisissez en dollars ; le système stocke en cents.",
      "invoiceTotal": "Total de la facture : {{amount}}",
      "reasonLabel": "Motif",
      "reasonPlaceholder": "Au moins 10 caractères — expliquez en détail (consigné dans le journal d'audit pour la conformité).",
      "reasonRemaining": "{{count}} caractères supplémentaires nécessaires (minimum {{min}}).",
      "reasonCount": "{{count}}/{{max}} caractères"
    }
  },
  "credit_memo": {
    "title": "Notes de crédit",
    "subtitle": "Notes de crédit émises par marchand",
    "columns": {
      "number": "N° de note",
      "merchant": "Marchand",
      "issuedAt": "Émise le",
      "amount": "Montant",
      "balance": "Solde restant",
      "status": "Statut",
      "reason": "Motif",
      "appliedTo": "Appliquée à",
      "actions": "Actions",
      "issuedBy": "Émise par",
      "notes": "Notes"
    },
    "actions": {
      "issue": "Émettre une note de crédit",
      "apply": "Appliquer à la facture",
      "void": "Annuler",
      "approving": "Approbation…",
      "applyShort": "Appliquer",
      "applyTooltip": "Appliquer ce crédit à une facture",
      "cancel": "Annuler"
    },
    "status": {
      "draft": "Brouillon",
      "issued": "Émise",
      "partiallyApplied": "Partiellement appliquée",
      "fullyApplied": "Entièrement appliquée",
      "voided": "Annulée"
    },
    "empty": {
      "title": "Aucune note de crédit",
      "body": "Émettez une note de crédit depuis le détail de la facture.",
      "none": "Aucune note de crédit trouvée",
      "filtered": "Aucune note de crédit ne correspond aux filtres actuels"
    },
    "approvals": {
      "title": "Approbations en attente",
      "approve": "Approuver",
      "reject": "Rejeter",
      "requestChanges": "Demander des modifications"
    },
    "filters": {
      "allStatuses": "Tous les statuts",
      "searchLabel": "Rechercher",
      "searchPlaceholder": "Rechercher un n° de note…",
      "searchAria": "Rechercher des notes de crédit",
      "statusAria": "Filtre de statut",
      "allMerchants": "Tous les marchands",
      "clear": "Effacer les filtres"
    },
    "filterOptions": {
      "active": "Active",
      "applied": "Appliquée",
      "partiallyApplied": "Partiellement appliquée",
      "converted": "Convertie",
      "refundedToBank": "Remboursée à la banque",
      "pendingApproval": "En attente d'approbation",
      "rejected": "Rejetée"
    },
    "reason": {
      "goodwill": "Geste commercial",
      "refund": "Remboursement",
      "overpayment": "Trop-perçu",
      "negotiated": "Négocié"
    },
    "badge": {
      "active": "Active",
      "pending": "En attente",
      "applied": "Appliquée",
      "partial": "Partielle",
      "converted": "Convertie",
      "refunded": "Remboursée",
      "rejected": "Rejetée",
      "dormant": "Inactive",
      "voided": "Annulée"
    },
    "stale": {
      "tooltip": "Inactive depuis plus de 12 mois — à annuler ou appliquer",
      "ariaLabel": "Note de crédit dormante (inactive depuis plus de 12 mois)",
      "label": "Dormante"
    },
    "list": {
      "subtitle": "Émettre des crédits, les appliquer aux factures, annuler si besoin",
      "pendingApprovalLink": "En attente d'approbation",
      "pendingApprovalLinkTooltip": "Ouvrir la file d'attente d'approbation",
      "loading": "Chargement des notes de crédit…"
    },
    "toast": {
      "loadFailed": "Échec du chargement des notes de crédit",
      "networkError": "Erreur réseau",
      "networkErrorDesc": "Erreur réseau - vérifiez la connexion",
      "adminRequired": "Rôle administrateur requis",
      "adminRequiredDesc": "Seul le rôle administrateur peut approuver les notes en attente.",
      "approveFailed": "Échec de l'approbation",
      "approved": "Note de crédit approuvée",
      "approvedDesc": "La note de crédit est maintenant active.",
      "genericError": "Une erreur est survenue"
    },
    "approvalsPage": {
      "title": "File d'attente d'approbation",
      "subtitle": "Notes de crédit en attente — celles émises par un comptable au-delà de 500 $ nécessitent une confirmation admin avant activation.",
      "readonlyPrefix": "Vous n'avez pas la permission",
      "readonlySuffix": "— vous pouvez seulement consulter la liste. Les boutons Approuver/Rejeter restent masqués jusqu'à l'obtention de l'accès admin.",
      "issuedByFilterLabel": "Émise par (comptable)",
      "allAccountants": "Tous les comptables",
      "amountMin": "Montant min (USD)",
      "amountMax": "Montant max (USD)",
      "loading": "Chargement des approbations en attente…",
      "emptyFiltered": "Aucune approbation en attente ne correspond aux filtres actuels",
      "emptyNone": "Aucune note de crédit en attente d'approbation",
      "overThresholdTooltip": "Plus de 500 $ — approbation admin requise",
      "loadFailed": "Échec du chargement des approbations en attente"
    },
    "apply": {
      "title": "Appliquer la note de crédit · {{id}}",
      "merchantLabel": "Marchand :",
      "remainingLabel": "Restant :",
      "invoiceLabel": "Facture (la plus ancienne d'abord)",
      "loadingInvoices": "Chargement des factures…",
      "noInvoicesPrefix": "Aucune facture ISSUED/PARTIAL/OVERDUE pour ce marchand. Créez une facture via",
      "noInvoicesSuffix": "d'abord, ou attendez le cycle de génération automatique.",
      "selectInvoicePlaceholder": "— Sélectionner une facture —",
      "outstanding": "dû",
      "amountLabel": "Montant (USD)",
      "amountPlaceholder": "ex. 25,00",
      "maxHint": "Max : {{max}} = min(crédit restant {{remaining}}, facture due {{outstanding}})",
      "amountTooHigh": "Le montant dépasse la limite — max {{max}}.",
      "submitting": "Application…",
      "errSelectInvoice": "Veuillez sélectionner une facture",
      "errAmountPositive": "Le montant doit être un nombre positif (USD)",
      "errAmountTooHigh": "Le montant dépasse la limite — max {{max}} (min du restant et du dû de la facture)",
      "errInvoiceNotFound": "Facture {{id}} introuvable",
      "errMissingVersion": "La réponse de la facture n'a pas le champ version — format inattendu",
      "errMerchantMismatch": "La facture appartient à un marchand différent de la note de crédit",
      "toastPaidTitle": "Crédit appliqué — facture PAYÉE",
      "toastAppliedTitle": "Note de crédit appliquée",
      "toastPaidDesc": "La facture {{invoice}} a été entièrement payée pour {{amount}}.",
      "toastAppliedDesc": "{{amount}} appliqué à la facture {{invoice}}."
    },
    "issue": {
      "merchantPlaceholder": "Sélectionner un marchand INVOICE…",
      "merchantHint": "Seuls les marchands en mode INVOICE sont éligibles aux notes de crédit.",
      "thresholdTitle": "Approbation requise.",
      "thresholdBefore": "Le montant dépasse 500 $ — les notes émises par un comptable au-delà de ce seuil sont dirigées vers la",
      "thresholdQueueLink": "file d'attente d'approbation",
      "thresholdAfter": ". Un administrateur doit l'approuver avant que le crédit ne devienne actif.",
      "notesPlaceholder": "Motif du crédit commercial (3 à 1000 caractères)…",
      "issueTypeLabel": "Type d'émission :",
      "issueTypeHint": "(les autres types sont émis automatiquement par les processus de remboursement/trop-perçu).",
      "submitTitleThreshold": "Sera dirigée vers la file d'attente d'approbation",
      "submitting": "Émission…",
      "submitForApproval": "Soumettre pour approbation",
      "submitDefault": "Émettre la note de crédit",
      "errMerchantRequired": "Marchand requis",
      "errAmountPositive": "Le montant doit être > 0",
      "errNotesMin": "Les notes doivent contenir au moins 3 caractères",
      "toastFailed": "Échec de l'émission de la note de crédit",
      "toastPendingTitle": "Note de crédit en attente d'approbation admin",
      "toastIssuedTitle": "Note de crédit émise",
      "toastPendingDesc": "Le montant dépasse 500 $ — dirigée vers la file d'attente d'approbation.",
      "toastIssuedDesc": "La note de crédit est maintenant active et peut être appliquée aux factures."
    },
    "actionsCell": {
      "approveTooltip": "Approuver la note de crédit (statut → Active)",
      "rejectTooltip": "Rejeter la note de crédit (statut → Rejetée)",
      "rejectModalTitle": "Rejeter la note de crédit",
      "memoLabel": "Note :",
      "amountLabel": "Montant :",
      "reasonLabel": "Motif du rejet",
      "reasonPlaceholder": "Expliquez le motif du rejet (au moins {{min}} caractères)…",
      "charCount": "{{count}} / {{max}} caractères (minimum {{min}})",
      "rejectNotice": "Après confirmation, le comptable émetteur recevra un email avec le motif du rejet. Une entrée de journal d'audit est créée automatiquement.",
      "rejecting": "Rejet…",
      "rejectSubmit": "Rejeter la note de crédit",
      "noApprovePerm": "Vous n'avez pas la permission d'approuver les notes de crédit.",
      "reasonRequired": "Le motif est obligatoire — minimum {{min}} caractères, maximum {{max}} caractères.",
      "alreadyResolvedTitle": "Note de crédit déjà traitée",
      "alreadyResolvedDesc": "Un autre administrateur vient de l'approuver/rejeter. Actualisation…",
      "rejectFailed": "Échec du rejet",
      "rejectedTitle": "Note de crédit rejetée",
      "rejectedDesc": "Note de crédit rejetée ; le comptable a été notifié."
    }
  },
  "refund_task": {
    "title": "Demandes de remboursement",
    "subtitle": "File d'approbation à 4 yeux",
    "columns": {
      "id": "ID tâche",
      "merchant": "Marchand",
      "amount": "Montant",
      "reason": "Motif",
      "requester": "Demandeur",
      "approver": "Approbateur",
      "status": "Statut"
    },
    "status": {
      "pendingApproval": "En attente d'approbation",
      "approved": "Approuvée",
      "rejected": "Rejetée",
      "processed": "Traitée",
      "failed": "Échouée"
    },
    "actions": {
      "approve": "Approuver",
      "reject": "Rejeter",
      "process": "Traiter le remboursement"
    },
    "errors": {
      "selfApproval": "Vous ne pouvez pas approuver votre propre demande",
      "alreadyProcessed": "Ce remboursement a déjà été traité",
      "generic": "Une erreur est survenue"
    },
    "relative": {
      "justNow": "à l'instant",
      "minutes": "il y a {{count}} min",
      "hours": "il y a {{count}} h",
      "days": "il y a {{count}} j"
    },
    "toast": {
      "networkError": "Erreur réseau",
      "networkErrorDescription": "Erreur réseau - vérifiez la connexion"
    },
    "filter": {
      "merchantLabel": "Filtre marchand",
      "merchantAria": "Filtre par ID marchand",
      "merchantPlaceholder": "ID marchand…",
      "clear": "Effacer"
    },
    "queue": {
      "title": "File des remboursements",
      "subtitle": "Remboursements par virement manuel — séparation des tâches appliquée (4 yeux).",
      "tab": {
        "pendingBankTransfer": "Virement en attente",
        "completed": "Terminé"
      },
      "column": {
        "taskNumber": "N° tâche",
        "merchant": "Marchand",
        "amount": "Montant",
        "bankAccount": "Compte bancaire",
        "createdBy": "Créé par",
        "completed": "Terminé",
        "created": "Créé le",
        "action": "Action"
      },
      "loading": "Chargement des remboursements…",
      "empty": "Aucun remboursement dans cette file",
      "sameUserTitle": "Identique à l'utilisateur actuel (blocage 4 yeux)",
      "youBadge": "vous",
      "completeBlockedTitle": "Impossible de finaliser un remboursement que vous avez créé (principe des 4 yeux). Un autre comptable ou admin doit le finaliser.",
      "completeTitle": "Marquer le remboursement comme terminé",
      "complete": "Finaliser",
      "refPrefix": "Réf : {{ref}}",
      "loadFailed": "Échec du chargement des remboursements"
    },
    "complete": {
      "proofInvalidFormat": "Format invalide. Seuls PDF, JPG ou PNG sont acceptés.",
      "proofTooLarge": "Le fichier dépasse la limite de 5 Mo (actuellement {{size}} Mo).",
      "bankRefMin": "La référence bancaire est requise (min {{min}} caractères)",
      "bankRefMax": "Référence bancaire trop longue (max {{max}} caractères)",
      "overrideReasonMin": "Le motif de dérogation est requis (min {{min}} caractères)",
      "overrideReasonMax": "Motif de dérogation trop long (max {{max}} caractères)",
      "sameUserAdmin": "Même utilisateur que le créateur — activez la dérogation admin + motif (4 yeux)",
      "sameUserNonAdmin": "Un autre comptable est requis (4 yeux)",
      "proofUploadFailed": "Échec du téléversement du justificatif. Retirez la pièce jointe et réessayez, ou contactez les ops.",
      "toastFailed": "Échec de la finalisation du remboursement",
      "toastStaleTitle": "Demande de remboursement introuvable",
      "toastStaleDesc": "Cette demande a déjà été traitée ou supprimée. La liste vient d'être actualisée.",
      "toastSuccess": "Remboursement terminé",
      "toastSuccessDesc": "Tâche {{taskNumber}} marquée comme terminée",
      "networkError": "Erreur réseau",
      "networkErrorDesc": "Erreur réseau - vérifiez la connexion",
      "title": "Finaliser le remboursement {{taskNumber}}",
      "summaryMerchant": "Marchand :",
      "summaryAmount": "Montant :",
      "summaryBankAccount": "Compte bancaire :",
      "summaryCreatedBy": "Créé par :",
      "bannerTitle": "Impossible de finaliser un remboursement que vous avez créé (principe des 4 yeux).",
      "bannerAdmin": "Un autre comptable ou admin doit finaliser. En tant qu'admin, vous pouvez déroger ci-dessous avec un motif écrit — la dérogation est auditée.",
      "bannerNonAdmin": "Un autre comptable ou admin doit finaliser. Demandez à un autre comptable (ou à un admin avec dérogation + motif) de finaliser cette tâche.",
      "bankRefLabel": "Référence bancaire",
      "bankRefPlaceholder": "ex. WIRE-20260517-9988",
      "bankRefHelp": "Requis — confirmation wire / SWIFT après le virement (audité).",
      "notesLabel": "Notes (facultatif)",
      "notesPlaceholder": "Notes internes — confirmation de virement, échanges, etc.",
      "proofLabel": "Relevé bancaire (facultatif)",
      "proofRemove": "Retirer",
      "proofHelp": "PDF / JPG / PNG, max 5 Mo. Stocké sur un serveur de fichiers dédié.",
      "overrideCheckbox": "Dérogation admin (séparation des tâches)",
      "overrideReasonLabel": "Motif de dérogation",
      "overrideReasonPlaceholder": "Pourquoi dérogez-vous aux 4 yeux ? (audité sous override_segregation)",
      "overrideReasonHelp": "Min {{min}} caractères. Écrit dans audit_log avec entity_type=override_segregation.",
      "cancel": "Annuler",
      "submitting": "Finalisation…",
      "submit": "Finaliser le remboursement"
    }
  },
  "payment_request": {
    "title": "Demandes de prépaiement",
    "subtitle": "Demandes manuelles en attente",
    "columns": {
      "number": "Numéro PR",
      "merchant": "Marchand",
      "amount": "Montant",
      "requestedAt": "Demandé le",
      "status": "Statut",
      "date": "Date",
      "legalEntity": "Entité légale",
      "createdBy": "Créé par"
    },
    "status": {
      "pending": "En attente",
      "approved": "Approuvée",
      "paid": "Payée",
      "rejected": "Rejetée",
      "expired": "Expirée"
    },
    "actions": {
      "approve": "Approuver",
      "reject": "Rejeter",
      "markPaid": "Marquer payée",
      "create": "Nouvelle demande de paiement"
    },
    "page": {
      "description": "Documents PDF envoyés aux marchands pour faciliter l'onboarding par virement. Une PR ne génère aucun flux de trésorerie et ne peut être modifiée après création."
    },
    "toast": {
      "created": "Demande de paiement créée",
      "createdDesc": "La PR {{prNumber}} apparaît désormais en haut de la liste."
    },
    "loading": "Chargement…",
    "empty": "Aucune demande de paiement pour l'instant.",
    "networkError": "Erreur réseau - vérifiez la connexion",
    "noPerm": "Vous n'avez pas la permission de créer des PR.",
    "noPermTitle": "Vous avez besoin de la permission pour créer une demande de paiement.",
    "filters": {
      "search": "Nom du marchand / N° PR",
      "searchPlaceholder": "Rechercher un marchand ou PR-YYYYMM-XXXXX",
      "from": "Du",
      "to": "Au",
      "searchBtn": "Rechercher"
    },
    "fields": {
      "name": "Nom",
      "phone": "Téléphone",
      "email": "Email",
      "business_name": "Raison sociale",
      "tax_id": "N° fiscal",
      "business_address": "Adresse professionnelle",
      "zip_code": "Code postal"
    },
    "form": {
      "merchantRequired": "Veuillez sélectionner un marchand.",
      "legalEntityRequired": "Veuillez sélectionner une entité légale.",
      "amountPositive": "Le montant doit être un nombre positif (USD).",
      "descriptionRequired": "La description est requise.",
      "descriptionMax": "Description max {{max}} caractères.",
      "createSuccess": "Demande de paiement créée avec succès",
      "createSuccessDesc": "PR {{prNumber}} créée pour le marchand.",
      "createSuccessFallback": "Nouvelle PR créée.",
      "title": "Créer une demande de paiement",
      "merchantInfoLegend": "Infos marchand sur le PDF",
      "loadingMerchant": "Chargement des infos marchand…",
      "empty": "(vide)",
      "toggleHint": "Activé + valeur vide → la ligne est ignorée sur le PDF.",
      "loadingShort": "Chargement…",
      "noLegalEntities": "Aucune entité légale pour l'instant",
      "selectLegalEntity": "Sélectionner une entité légale",
      "defaultSuffix": " (par défaut)",
      "bankAccount": "Compte bancaire",
      "selectLegalEntityFirst": "Sélectionnez d'abord une entité légale",
      "selectBankAccount": "Sélectionner un compte bancaire",
      "primarySuffix": " · principal",
      "amount": "Montant (USD)",
      "description": "Description",
      "descriptionHelp": "{{count}}/{{max}} caractères · pré-rempli avec « {{default}} », modifiable par l'admin.",
      "cancel": "Annuler",
      "creating": "Création…",
      "submit": "Créer la PR"
    },
    "pdf": {
      "title": "Demande de paiement",
      "iframeTitle": "Aperçu PDF de la demande de paiement {{prNumber}}",
      "notReady": "PDF pas encore prêt.",
      "notReadyHint": "Le PDF est généré de façon asynchrone — réessayez dans ~30 secondes.",
      "close": "Fermer",
      "download": "Télécharger PDF"
    }
  },
  "legal_entity": {
    "title": "Entités légales",
    "subtitle": "Entités de facturation et comptes bancaires",
    "columns": {
      "name": "Nom",
      "taxId": "N° fiscal",
      "country": "Pays",
      "bankAccount": "Compte bancaire",
      "isActive": "Active",
      "legalName": "Nom légal",
      "taxConfig": "Config fiscale",
      "timezone": "Fuseau horaire",
      "invoices": "Factures",
      "created": "Créée le",
      "actions": "Actions"
    },
    "actions": {
      "create": "Ajouter une entité",
      "edit": "Modifier",
      "deactivate": "Désactiver",
      "addBankAccount": "Ajouter un compte",
      "assignMerchant": "Assigner un marchand",
      "delete": "Supprimer"
    },
    "tabs": {
      "details": "Détails",
      "bankAccounts": "Comptes bancaires",
      "merchants": "Marchands"
    },
    "fields": {
      "name": "Nom légal",
      "taxId": "N° fiscal / TVA",
      "country": "Pays",
      "address": "Adresse",
      "currency": "Devise par défaut",
      "active": "Active"
    },
    "errors": {
      "duplicateTaxId": "Une entité avec ce N° fiscal existe déjà",
      "cannotDeactivate": "Impossible de désactiver — entité liée à des marchands actifs",
      "noOtherEntity": "Aucune autre entité à laquelle appliquer le logo."
    },
    "common": {
      "cancel": "Annuler",
      "remove": "Retirer",
      "removing": "Retrait…",
      "networkTitle": "Erreur réseau",
      "networkDesc": "Erreur réseau — vérifiez la connexion"
    },
    "page": {
      "subtitle": "Registre multi-entités — les factures/reçus sont émis par entité. Chaque entité conserve sa propre config fiscale (VAT / GST / SALES_TAX / NONE) et son fuseau horaire IANA pour le cron de facturation.",
      "newEntity": "+ Nouvelle entité",
      "searchPlaceholder": "Rechercher par nom ou N° fiscal…",
      "sort": "Trier",
      "sortNewest": "Plus récentes d'abord",
      "sortOldest": "Plus anciennes d'abord",
      "sortName": "Nom (A→Z)",
      "loading": "Chargement des entités légales…",
      "loadError": "Échec du chargement : {{error}}",
      "retry": "Réessayer",
      "empty": "Aucune entité légale pour le moment — cliquez sur \"+ Nouvelle entité\" pour créer Printway HK.",
      "defaultBadge": "Par défaut",
      "taxMissingTip": "Avertissement de migration : la config fiscale n'est pas définie pour cette entité.",
      "taxNotConfigured": "Taxe non configurée",
      "timezoneMissingTip": "Avertissement de migration : le fuseau horaire n'est pas défini — le cron de facturation ignorera cette entité.",
      "timezoneNotSet": "Fuseau horaire non défini",
      "loadingShort": "Chargement…",
      "setDefault": "Définir par défaut"
    },
    "toasts": {
      "loadDetailFailed": "Échec du chargement de l'entité",
      "setDefaultSuccess": "Définie par défaut",
      "setDefaultFailed": "Échec de la définition par défaut",
      "deleteBlockedTitle": "Suppression impossible",
      "deleteSuccess": "Entité légale supprimée",
      "deleteFailed": "Échec de la suppression"
    },
    "logo": {
      "unknownError": "erreur inconnue",
      "syncPartial": "Synchronisé {{done}}/{{total}} entités. Erreurs : {{errors}}"
    },
    "delete": {
      "inUseDesc": "Des factures/reçus référencent encore \"{{name}}\" ({{count}} documents). L'archivage logiciel conserve l'instantané sur les documents existants.",
      "defaultBlockedTitle": "Impossible de supprimer l'entité par défaut",
      "defaultBlockedDesc": "Définissez une autre entité par défaut avant de supprimer l'entité actuelle."
    },
    "setDefaultConfirm": {
      "title": "Définir comme entité légale par défaut ?",
      "desc": "Les nouvelles factures/reçus émis sans entité spécifiée utiliseront \"{{name}}\". Les documents existants conservent leur instantané."
    },
    "deleteConfirm": {
      "title": "Supprimer l'entité légale ?",
      "desc": "Supprimer \"{{name}}\" ({{taxId}}). Le système bloque la suppression si {{count}} factures/reçus la référencent ou s'il s'agit de l'entité par défaut."
    },
    "form": {
      "editTitle": "Modifier l'entité légale",
      "createTitle": "Nouvelle entité légale",
      "editNote": "Note : les modifications ne s'appliquent qu'aux factures/reçus émis désormais (modèle d'instantané — les documents existants conservent les détails de l'entité capturés au moment de l'émission).",
      "legacyTimezoneWarning": "Entité héritée — fuseau horaire non défini. Définissez un fuseau horaire pour activer le cron de facturation.",
      "codeLabel": "Code entité",
      "codeHelp": "UPPER_SNAKE — utilisé dans le préfixe de séquence facture / reçu.",
      "countryLabel": "Pays (ISO-2)",
      "taxIdLabel": "N° fiscal (legal_id)",
      "taxIdHelp": "Doit être unique parmi les entités.",
      "nameLabel": "Nom légal",
      "addressLabel": "Adresse",
      "bankInfoLabel": "Infos bancaires",
      "bankInfoPlaceholder": "DBS Bank HK / Account 63000304744 / SWIFT DHBKHKHH",
      "logoLabel": "Logo",
      "logoHelper": "PNG / JPEG / WEBP / SVG ≤ 2 Mo. Affiché sur le PDF de facture + le PDF de demande de paiement.",
      "applying": "Application…",
      "applyToAll": "Appliquer à tous",
      "timezoneLabel": "Fuseau horaire (IANA)",
      "timezoneWarning": "Fuseau horaire non défini — définissez un fuseau horaire pour activer le cron de facturation.",
      "saving": "Enregistrement…",
      "creating": "Création…",
      "saveChanges": "Enregistrer les modifications",
      "createEntity": "Créer l'entité",
      "logoMissingTitle": "Pas encore d'URL de logo",
      "logoMissingDesc": "Saisissez une URL de logo avant de l'appliquer aux autres entités.",
      "logoSyncedTitle": "Logo synchronisé",
      "logoSyncedDesc": "Le logo a été copié sur les autres entités légales.",
      "logoSyncFailed": "Échec de la synchronisation du logo",
      "logoApplyFailedTitle": "Échec de l'application du logo",
      "duplicateTaxCode": "Le N° fiscal/Code est déjà utilisé par une autre entité",
      "preconditionFailed": "L'enregistrement a été modifié dans une autre session. Fermez et rouvrez pour charger la dernière version.",
      "updateFailed": "Échec de la mise à jour de l'entité",
      "createFailed": "Échec de la création de l'entité",
      "updateSuccess": "Entité légale mise à jour",
      "createSuccess": "Entité légale créée"
    },
    "merchants": {
      "pickRequired": "Choisissez un marchand dans la liste de recherche.",
      "alreadyAssigned": "Ce marchand est déjà affecté à l'entité.",
      "alreadyAssignedShort": "Marchand déjà affecté.",
      "assignFailed": "Échec de l'affectation du marchand",
      "reassignedTitle": "Marchand déplacé vers cette entité",
      "assignedTitle": "Marchand affecté",
      "reassignedDesc": "Le marchand a été retiré de son entité précédente et rattaché à l'entité actuelle. Les instantanés des documents existants restent inchangés.",
      "notFoundTitle": "L'affectation n'existe pas",
      "removeFailed": "Échec du retrait du marchand",
      "removedFallbackDesc": "Le marchand utilisera l'entité par défaut (id {{id}}…) pour les nouveaux documents. Les instantanés existants restent inchangés.",
      "removedDesc": "Le marchand utilisera l'entité par défaut pour les nouveaux documents.",
      "removedTitle": "Marchand retiré de l'entité",
      "snapshotWarning": "Cette entité dessert {{count}} documents. Les modifications d'affectation de marchand ne s'appliquent qu'aux documents émis ensuite — les instantanés existants restent inchangés.",
      "readonly": "Vous n'avez pas la permission de modifier la liste des marchands (nécessite legal_entity:write).",
      "assignHeading": "Affecter un marchand",
      "assignSubheading": "Les marchands non affectés utilisent l'entité par défaut.",
      "searchLabel": "Trouver un marchand",
      "searchPlaceholder": "Recherche par nom, email ou ID",
      "assigning": "Affectation…",
      "addBtn": "Ajouter un marchand",
      "empty": "Aucun marchand affecté pour le moment. Chaque marchand utilise l'entité par défaut.",
      "col": {
        "merchant": "Marchand",
        "email": "Email",
        "assigned": "Affecté le",
        "actions": "Actions"
      }
    },
    "bank": {
      "errGateway": "Obligatoire — choisissez une passerelle de paiement",
      "errRequired": "Obligatoire",
      "errSwift": "Le SWIFT doit comporter 8 ou 11 caractères alphanumériques majuscules",
      "errPrimaryExists": "Cette entité a déjà une banque principale — décochez la principale actuelle d'abord, ou créez une non-principale puis modifiez-la ensuite.",
      "errSwiftInvalid": "SWIFT invalide",
      "addFailed": "Échec de l'ajout du compte bancaire",
      "addedSnapshotTitle": "Banque ajoutée — instantané inchangé",
      "addedSnapshotDesc": "Les factures/demandes de prépaiement déjà émises conservent les détails bancaires capturés au moment de l'émission (instantané).",
      "addedTitle": "Compte bancaire ajouté",
      "removePrimaryTitle": "Impossible de supprimer la banque principale",
      "removePrimaryDesc": "Définissez une autre banque comme principale avant de supprimer la banque principale actuelle.",
      "removeBlockedTitle": "Impossible de supprimer la banque",
      "removePrimary422": "La banque principale ne peut pas être supprimée — définissez d'abord un autre compte comme principal.",
      "removeFailed": "Échec de la suppression du compte bancaire",
      "removedSnapshotTitle": "Banque retirée — instantané conservé",
      "removedSnapshotDesc": "Les documents existants référençant cette banque affichent toujours les détails capturés au moment de l'émission.",
      "removedTitle": "Compte bancaire supprimé",
      "legend": "Comptes bancaires",
      "snapshotWarning": "Cette entité est référencée par {{count}} factures/PR. Toute modification bancaire n'affecte que les documents émis après l'enregistrement — les instantanés existants restent inchangés.",
      "readonly": "Vous n'avez pas la permission de modifier les comptes bancaires (nécessite la permission legal_entity:write).",
      "col": {
        "holder": "Titulaire · Passerelle",
        "number": "Numéro de compte",
        "swift": "SWIFT",
        "primary": "Principal",
        "actions": "Actions"
      },
      "empty": "Aucun compte bancaire pour le moment. Cliquez sur \"+ Add bank\" pour créer la banque principale.",
      "primaryBadge": "Principal",
      "addBankBtn": "+ Ajouter une banque",
      "adding": "Ajout…",
      "addBankSubmit": "Ajouter une banque",
      "gatewayLabel": "Passerelle de paiement",
      "gatewayBankTransfer": "Virement bancaire",
      "holderLabel": "Titulaire du compte",
      "numberLabel": "Numéro de compte",
      "nameLabel": "Nom de la banque",
      "locationLabel": "Localisation de la banque",
      "typeLabel": "Type de compte",
      "swiftLabel": "Code SWIFT",
      "swiftPlaceholder": "HSBCHKHHHKH (8 ou 11 caractères)",
      "swiftHelp": "Laissez vide si non applicable. Le SWIFT doit comporter 8 ou 11 caractères alphanumériques.",
      "codeLabel": "Code banque",
      "branchLabel": "Code agence",
      "branchPlaceholder": "Identifiant d'agence",
      "addressLabel": "Adresse de la banque",
      "setPrimaryLabel": "Définir comme banque principale pour cette entité",
      "primaryHelp": "Une seule banque peut être cochée comme principale par entité. Décochez la banque principale actuelle avant de cocher principale pour une nouvelle banque.",
      "typePlaceholder": "Courant / Épargne / Entreprise",
      "namePlaceholder": "HSBC Hong Kong",
      "locationPlaceholder": "Central, Hong Kong",
      "codePlaceholder": "Routing / ABA / IFSC"
    },
    "tax": {
      "legend": "Configuration fiscale",
      "noneHint": "Type = NONE — l'entité n'émet pas de factures fiscales. Les champs ci-dessous sont désactivés.",
      "requiredHint": "Le numéro d'enregistrement + le taux standard sont requis pour VAT/GST/SALES_TAX.",
      "typeLabel": "Type de taxe",
      "typeNone": "NONE (sans taxe)",
      "rateLabel": "Taux standard (%)",
      "ratePlaceholder": "ex. 10 = 10%",
      "rateHelp": "0–30% (stocké en fraction décimale).",
      "regLabel": "Numéro d'enregistrement",
      "regPlaceholder": "N° d'enregistrement VAT/GST",
      "jurisdictionLabel": "Juridiction (ISO-3166)",
      "jurisdictionAuto": "Suggéré automatiquement d'après le pays de l'adresse : {{country}}.",
      "invoiceLabelLabel": "Libellé fiscal sur la facture",
      "invoiceLabelPlaceholder": "ex. \"VAT 10%\"",
      "reverseChargeLabel": "Éligible à l'autoliquidation",
      "reverseChargeHint": "(activé par défaut pour le B2B UE)",
      "jurisdictions": {
        "HK": "HK — Hong Kong",
        "VN": "VN — Vietnam",
        "SG": "SG — Singapour",
        "CN": "CN — Chine",
        "JP": "JP — Japon",
        "KR": "KR — Corée du Sud",
        "TH": "TH — Thaïlande",
        "MY": "MY — Malaisie",
        "PH": "PH — Philippines",
        "ID": "ID — Indonésie",
        "IN": "IN — Inde",
        "AE": "AE — Émirats arabes unis",
        "AU": "AU — Australie",
        "NZ": "NZ — Nouvelle-Zélande",
        "GB": "GB — Royaume-Uni",
        "DE": "DE — Allemagne",
        "FR": "FR — France",
        "NL": "NL — Pays-Bas",
        "IT": "IT — Italie",
        "ES": "ES — Espagne",
        "IE": "IE — Irlande",
        "US": "US — États-Unis",
        "US-CA": "US-CA — Californie",
        "US-NY": "US-NY — New York",
        "US-TX": "US-TX — Texas",
        "US-WA": "US-WA — Washington",
        "CA": "CA — Canada"
      }
    },
    "timezone": {
      "searchPlaceholder": "Rechercher un fuseau horaire (ex. Asia/Hong_Kong, hong, new york)…",
      "noMatch": "Aucun fuseau horaire ne correspond à \"{{query}}\".",
      "helper": "Le cron de facturation exécutera les cycles dans ce fuseau horaire."
    }
  },
  "aging_report": {
    "title": "Rapport d'antériorité",
    "subtitle": "Analyse Brut + Net + DSO",
    "buckets": {
      "current": "À jour",
      "1to30": "1-30 jours",
      "31to60": "31-60 jours",
      "61to90": "61-90 jours",
      "over90": "Plus de 90 jours"
    },
    "metrics": {
      "gross": "AR Brut",
      "net": "AR Net",
      "dso": "DSO (jours de ventes en cours)"
    },
    "filters": {
      "asOfDate": "À la date",
      "merchant": "Marchand",
      "merchantPlaceholder": "Sélectionner un marchand…"
    },
    "actions": {
      "export": "Exporter CSV",
      "refresh": "Actualiser"
    },
    "page": {
      "description": "Créances en cours regroupées par ancienneté (Brut vs Net)"
    },
    "bucketLabels": {
      "0-7d": "0-7 JOURS",
      "8-30d": "8-30 JOURS",
      "30d+": "30+ JOURS"
    },
    "tooltips": {
      "grossNet": "Brut = factures impayées + charges non facturées. Net = Brut - notes de crédit actives (Printway doit au marchand).",
      "dso": "DSO = nombre moyen de jours entre l'émission de la facture et le paiement. Plus c'est bas, mieux c'est."
    },
    "toast": {
      "loadFailed": "Échec du chargement du rapport d'antériorité",
      "networkError": "Erreur réseau - vérifiez la connexion",
      "unexpectedShape": "Format de réponse inattendu du serveur.",
      "unknownError": "Erreur inconnue"
    },
    "tiles": {
      "dso": "DSO (JOURS)",
      "dsoSub": "Jours de ventes en cours",
      "totalGross": "TOTAL BRUT",
      "totalNet": "TOTAL NET",
      "netSub": "Après notes de crédit actives",
      "invoicesCount": "{{count}} factures"
    },
    "byMerchant": {
      "title": "Par marchand",
      "hint": "Cliquez sur une cellule de tranche pour explorer les factures correspondantes.",
      "colDso": "DSO",
      "colGross": "Brut en cours",
      "colNet": "Net en cours",
      "overall": "Global"
    },
    "loading": "Chargement du rapport d'antériorité…",
    "loadingShort": "Chargement…",
    "empty": {
      "title": "Aucune créance en cours",
      "body": "Toutes les factures ont été payées ou il n'y a pas encore de marchands en mode INVOICE. Les tranches d'antériorité apparaîtront ici lorsque les factures dépasseront leur échéance."
    }
  },
  "transfer_group": {
    "title": "Groupes de transfert",
    "subtitle": "Groupes de marchands pour paiements",
    "columns": {
      "name": "Nom du groupe",
      "memberCount": "Membres",
      "createdAt": "Créé le",
      "isActive": "Actif",
      "description": "Description",
      "owner": "Propriétaire",
      "perMemberLimit": "Plafond par membre",
      "status": "Statut",
      "actions": "Actions"
    },
    "actions": {
      "create": "Créer un groupe",
      "edit": "Modifier",
      "addMember": "Ajouter un membre",
      "removeMember": "Retirer un membre",
      "members": "Membres",
      "deactivate": "Désactiver",
      "deactivated": "Désactivé",
      "history": "Historique",
      "reactivate": "Réactiver"
    },
    "page": {
      "description": "Liste blanche de cohortes de marchands autorisés aux transferts entre pairs. Gérez les membres et les plafonds de transfert par membre. Le blocage de transfert se gère dans le détail du marchand."
    },
    "toast": {
      "loadFailed": "Échec du chargement des groupes",
      "networkError": "Erreur réseau",
      "checkConnection": "Vérifiez la connexion",
      "deactivateFailed": "Échec de la désactivation du groupe",
      "deactivated": "Groupe désactivé",
      "networkErrorDesc": "Erreur réseau — vérifiez la connexion",
      "unknownError": "Erreur inconnue",
      "reactivated": "Groupe réactivé",
      "reactivateFailed": "Échec de la réactivation du groupe"
    },
    "loading": "Chargement des groupes…",
    "empty": "Aucun groupe de transfert pour l'instant. Cliquez sur « + Créer un groupe » pour en créer un.",
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    },
    "alreadyInactive": "Le groupe est déjà inactif",
    "confirm": {
      "deactivateTitle": "Désactiver « {{name}} » ?",
      "deactivateDesc": "Le groupe sera marqué inactif. Les membres existants perdent leurs privilèges de transfert. Réactivez via Modifier plus tard."
    },
    "form": {
      "nameRequired": "Le nom est requis",
      "nameTooLong": "Nom trop long (max 80 caractères)",
      "minNumber": "Le montant min doit être un nombre",
      "maxNumber": "Le montant max doit être un nombre",
      "minMax": "Le montant min doit être ≤ au max",
      "nameTaken": "Ce nom de groupe existe déjà",
      "updateFailed": "Échec de la mise à jour",
      "createFailed": "Échec de la création",
      "updated": "Groupe mis à jour",
      "created": "Groupe créé",
      "editTitle": "Modifier le groupe de transfert",
      "createTitle": "Nouveau groupe de transfert",
      "nameLabel": "Nom",
      "namePlaceholder": "ex. East-Asia Hub",
      "nameHelp": "Unique sur la plateforme. 1 à 80 caractères.",
      "descriptionPlaceholder": "Marchands de la région JP/KR/CN",
      "minAmount": "Montant min (USD)",
      "maxAmount": "Montant max (USD)",
      "cancel": "Annuler",
      "saving": "Enregistrement…",
      "creating": "Création…",
      "saveChanges": "Enregistrer",
      "createGroup": "Créer le groupe",
      "amountDecimals": "Le montant admet au plus 2 décimales",
      "amountNegative": "Le montant ne peut pas être négatif"
    },
    "members": {
      "loadFailed": "Échec du chargement des membres",
      "historyLoadFailed": "Échec du chargement de l'historique",
      "pickMerchant": "Choisissez un marchand dans les résultats",
      "alreadyMember": "Ce marchand est déjà membre.",
      "added": "Membre ajouté",
      "removeFailed": "Échec de la suppression du membre",
      "removed": "Membre supprimé",
      "title": "Gérer le groupe — {{name}}",
      "readonlyBadge": "Inactif (lecture seule)",
      "membersTab": "Membres ({{count}})",
      "historyTab": "Historique",
      "addMerchant": "Ajouter un marchand",
      "inactiveHint": "Groupe inactif — réactivez via Modifier pour ajouter des membres.",
      "searchMerchant": "Rechercher un marchand",
      "searchPlaceholder": "Rechercher par nom, email ou ID",
      "unlimited": "Illimité (aucun plafond par membre)",
      "maxPerTransfer": "Max par transfert (centimes)",
      "maxCount": "Nombre max / mois",
      "adding": "Ajout…",
      "addMemberBtn": "Ajouter un membre",
      "colMerchant": "Marchand",
      "colPerTransfer": "Par transfert",
      "colPerMonth": "Par mois",
      "colStatus": "Statut",
      "colActions": "Actions",
      "loadingMembers": "Chargement des membres…",
      "noMembers": "Aucun membre pour l'instant.",
      "unlimitedValue": "Illimité",
      "perMonthSuffix": "{{count}}/mois",
      "blocked": "Bloqué",
      "blockedReason": "Bloqué — {{reason}}",
      "blockedTooltip": "Bloqué pour les transferts. Débloquez via le détail du marchand.",
      "remove": "Retirer",
      "historyBlurb": "Transferts récents au sein de ce groupe. Utilisez le lien pour le filtre Transactions complet, ou l'export CSV pour un export d'audit.",
      "viewInTransactions": "Voir dans Transactions",
      "exportCsv": "Exporter CSV",
      "histDate": "Date",
      "histSender": "Expéditeur",
      "histReceiver": "Destinataire",
      "histAmount": "Montant",
      "loadingHistory": "Chargement de l'historique…",
      "noTransfers": "Aucun transfert pour l'instant.",
      "close": "Fermer",
      "noWallet": "Aucun portefeuille",
      "noWalletTooltip": "Ce marchand n'a pas encore de portefeuille actif — il ne peut pas recevoir de transferts tant que l'intégration n'est pas terminée."
    },
    "history": {
      "title": "Historique des transferts — {{name}}",
      "loading": "Chargement…",
      "empty": "Aucun transfert routé via ce groupe pour le moment.",
      "date": "Date",
      "sender": "Expéditeur",
      "recipient": "Destinataire",
      "amount": "Montant",
      "note": "Note",
      "exportCsv": "Exporter CSV",
      "close": "Fermer"
    }
  },
  "topup_review": {
    "title": "Revue des recharges",
    "subtitle": "Recharges par virement en attente",
    "columns": {
      "merchant": "Marchand",
      "amount": "Montant",
      "bank": "Banque",
      "reference": "Référence",
      "uploadedAt": "Téléchargée le",
      "status": "Statut"
    },
    "status": {
      "pending": "En attente",
      "approved": "Approuvée",
      "rejected": "Rejetée"
    },
    "actions": {
      "approve": "Approuver",
      "reject": "Rejeter",
      "viewProof": "Voir la preuve"
    },
    "fields": {
      "verification": "Note de vérification",
      "rejectionReason": "Motif du rejet"
    },
    "unknown": "Inconnu",
    "networkError": "Erreur réseau — vérifiez la connexion",
    "relative": {
      "seconds": "il y a {{count}} s",
      "minutes": "il y a {{count}} min",
      "hours": "il y a {{count}} h",
      "days": "il y a {{count}} j",
      "months": "il y a {{count}} mois"
    },
    "raceLoser": {
      "title": "Déjà traité par un autre admin",
      "description": "Cette demande a déjà été approuvée/rejetée par un autre admin — la liste a été actualisée."
    },
    "queue": {
      "title": "File des recharges",
      "subtitle": "Examinez et approuvez les recharges manuelles (la plus ancienne d'abord)",
      "queuePill": "La plus ancienne d'abord · {{count}} dans la file",
      "exportCsv": "Exporter CSV",
      "tab": {
        "all": "Tout",
        "pending": "En attente",
        "approved": "Approuvé",
        "rejected": "Rejeté",
        "flagged": "Signalé"
      },
      "filter": {
        "merchant": "Marchand",
        "allMerchants": "Tous les marchands",
        "gateway": "Passerelle",
        "allGateways": "Toutes les passerelles",
        "from": "Du",
        "to": "Au",
        "clear": "Effacer les filtres"
      },
      "loading": "Chargement de la file des recharges…",
      "column": {
        "id": "ID",
        "merchant": "Marchand",
        "amount": "Montant",
        "gateway": "Passerelle",
        "txId": "ID transaction",
        "date": "Date",
        "status": "Statut",
        "actions": "Actions"
      },
      "flaggedTitle": "Signalé pour examen anti-fraude",
      "approve": "Approuver",
      "cancel": "Annuler",
      "autoWebhook": "Auto via webhook",
      "reject": "Rejeter",
      "review": "Examiner",
      "loadFailed": "Échec du chargement de la file des recharges",
      "detailLoadFailed": "Échec du chargement du détail de la demande",
      "forceOverrideMin": "L'approbation forcée requiert un motif d'au moins 10 caractères (journal d'audit).",
      "approveFailed": "Échec de l'approbation",
      "approveSuccess": "Recharge approuvée",
      "approveSuccessDesc": "Portefeuille crédité et marchand notifié.",
      "rejectReasonMin": "Le motif de rejet est requis (min 3 caractères).",
      "rejectFailed": "Échec du rejet",
      "rejectSuccess": "Recharge rejetée",
      "rejectSuccessDesc": "Marchand notifié avec le motif.",
      "flagFailed": "Échec du basculement du signalement",
      "flagMarked": "Marqué comme suspect",
      "flagCleared": "Signalement retiré",
      "flagDesc": "Interne uniquement — le marchand n'est pas notifié.",
      "confirmApproveTitleAmount": "Approuver la recharge de {{amount}} ?",
      "confirmApproveTitle": "Approuver la recharge ?",
      "forceApproveTier1Bold": "Approbation forcée tier-1.",
      "forceApproveTier1Body": "Le tier-1 est habituellement approuvé automatiquement par webhook. Un motif d'au moins 10 caractères est requis — il sera consigné dans le journal d'audit.",
      "confirmApproveBody": "Ceci crédite le portefeuille du marchand et écrit une écriture comptable. Irréversible.",
      "forceOverridePlaceholder": "Motif d'approbation forcée (≥10 caractères, journal d'audit)",
      "internalNotePlaceholder": "Note interne (piste d'audit, facultatif)",
      "forceApprove": "Approbation forcée",
      "emptyTitle": "Aucune recharge dans cette vue",
      "emptyBody": "Lorsque les marchands soumettent des recharges, elles apparaissent ici pour examen."
    },
    "drawer": {
      "closeDrawer": "Fermer le panneau",
      "close": "Fermer",
      "fallbackName": "Demande de recharge",
      "loading": "Chargement…",
      "flagged": "Signalé",
      "flagAsSuspicious": "Signaler comme suspect",
      "amount": "Montant",
      "original": "D'origine :",
      "fxLocked": " · FX verrouillé @ {{rate}}",
      "gateway": "Passerelle",
      "tier": "Tier",
      "transactionId": "ID transaction",
      "receipt": "Reçu",
      "openReceipt": "Ouvrir le reçu",
      "download": "Télécharger",
      "merchantNote": "Note du marchand",
      "createdAt": "Créé le",
      "approvedAt": "Approuvé le",
      "rejectedReason": "Motif du rejet",
      "rejectThis": "Rejeter cette demande",
      "reason": "Motif",
      "rejectReasonPlaceholder": "Motif du rejet (envoyé au marchand)",
      "internalNote": "Note interne (piste d'audit, facultatif)",
      "internalNotePlaceholder": "Visible par l'équipe admin uniquement",
      "reject": "Rejeter",
      "approve": "Approuver",
      "tier1AutoWebhook": "Tier 1 — auto via webhook",
      "forceApproveTitle": "Contourner l'auto-approbation tier-1 (journalisé)",
      "forceApprove": "Approbation forcée"
    },
    "reviews": {
      "title": "Revue des recharges",
      "subtitle": "Les lignes auto-vérifiées s'approuvent en un clic. Les lignes en revue manuelle ouvrent le modal de preuve à 4 sections.",
      "overdue": "{{count}} en retard (violation SLA)",
      "approveSuccessDescRef": "Portefeuille crédité. Réf : {{ref}}.",
      "approveSuccessDesc": "Portefeuille crédité.",
      "rejectSuccessDescReason": "Rejeté — motif : {{reason}}.",
      "rejectSuccessDesc": "Recharge rejetée.",
      "loading": "Chargement des revues de recharge…",
      "errorTitle": "Échec du chargement des revues.",
      "retry": "Réessayer",
      "emptyTitle": "Aucune revue de recharge dans cette vue",
      "emptyBody": "Essayez d'effacer les filtres ou de changer de statut.",
      "merchantFallback": "Marchand …{{id}}",
      "ageMinutes": "Ancienneté : {{count}} min",
      "approving": "Approbation…",
      "filter": {
        "status": "Statut",
        "all": "Tout",
        "verification": "Vérification",
        "sla": "SLA",
        "slaFresh": "Récent (< 2h)",
        "slaYellow": "Jaune (2-4h)",
        "slaRed": "Rouge (> 4h)",
        "merchant": "Marchand"
      },
      "verification": {
        "auto": "Auto-vérifié",
        "manual": "Revue manuelle"
      },
      "slaBadge": {
        "green": "VERT",
        "yellow": "JAUNE",
        "red": "ROUGE"
      },
      "column": {
        "merchant": "Marchand",
        "amount": "Montant",
        "verification": "Vérification",
        "sla": "SLA",
        "created": "Créé le",
        "status": "Statut",
        "rejectReason": "Motif de rejet",
        "reviewer": "Réviseur",
        "actions": "Actions"
      },
      "cancelledByMerchant": "Annulé par le marchand"
    },
    "modal": {
      "ariaLabel": "Revue du justificatif de recharge",
      "title": "Revue du justificatif de recharge",
      "ageMinutes": "Ancienneté : {{count}} min",
      "sla": "SLA : {{age}}",
      "section1Title": "1. Source IMAP",
      "section1Subtitle": "Corps brut de l'e-mail bancaire + champs analysés par le serveur",
      "parsed": "Analysé",
      "sender": "Expéditeur",
      "amount": "Montant",
      "memo": "Mémo",
      "timestamp": "Horodatage",
      "rawImap": "Corps IMAP brut",
      "noImap": "(aucun corps IMAP capturé)",
      "section2Title": "2. Mémo du marchand",
      "section2Subtitle": "Texte libre soumis par le marchand avec la recharge",
      "noMemo": "(aucun mémo)",
      "section3Title": "3. Capture d'écran / justificatif",
      "section3Subtitle": "≤5 Mo · appliqué côté serveur",
      "screenshotAlt": "Capture du justificatif de recharge",
      "noScreenshot": "(aucune capture téléversée)",
      "screenshotOpen": "Ouvrir le justificatif dans un nouvel onglet",
      "screenshotLoadFailed": "Impossible de charger l'image du justificatif. Ouvrez-la dans un nouvel onglet ci-dessous.",
      "section4Title": "4. Contexte du portefeuille",
      "section4Subtitle": "Solde · transactions récentes · indicateurs suspects",
      "walletBalance": "Solde du portefeuille",
      "suspiciousFlags": "Indicateurs suspects",
      "recentTransactions": "Transactions récentes",
      "noTransactions": "(aucune transaction récente sur la période)",
      "approveNotes": "Notes d'approbation (facultatif)",
      "approveNotesPlaceholder": "Note interne facultative — consignée au journal d'audit",
      "rejectThis": "Rejeter cette recharge",
      "rejectReasonAria": "Motif du rejet",
      "selectReason": "Sélectionner un motif…",
      "freeTextPlaceholder": "Motif libre (requis)",
      "cancel": "Annuler",
      "reject": "Rejeter",
      "approve": "Approuver",
      "selectReasonError": "Veuillez sélectionner un motif de rejet.",
      "otherRequiredError": "Un motif est requis lorsque \"Other\" est sélectionné.",
      "rejectReason": {
        "wrong_amount": "Montant incorrect",
        "wrong_memo": "Mémo incorrect",
        "unknown_sender": "Expéditeur inconnu",
        "duplicate": "Doublon",
        "suspicious": "Suspect",
        "missing_proof": "Justificatif manquant",
        "other": "Autre (motif libre requis)"
      }
    }
  },
  "credit": {
    "title": "Crédits",
    "subtitle": "Soldes de crédit inter-marchands",
    "columns": {
      "merchant": "Marchand",
      "balance": "Solde",
      "lastTopup": "Dernière recharge",
      "lifetime": "Dépense totale",
      "amount": "Montant",
      "used": "Utilisé",
      "remaining": "Restant",
      "expiresAt": "Expire le",
      "reason": "Motif",
      "createdBy": "Créé par",
      "version": "Version",
      "status": "Statut",
      "actions": "Actions"
    },
    "actions": {
      "grant": "Accorder un crédit",
      "revoke": "Révoquer",
      "viewHistory": "Voir l'historique"
    },
    "filters": {
      "merchant": "Marchand",
      "minBalance": "Solde min",
      "maxBalance": "Solde max",
      "merchantLabel": "Marchand (recherche par nom / email)",
      "merchantPlaceholder": "Tous les marchands",
      "clear": "Effacer les filtres",
      "statusLabel": "Statut",
      "statusAria": "Statut du crédit",
      "expiryLabel": "Expire sous",
      "expiryAria": "Plage d'expiration"
    },
    "listSubtitle": "Crédits inter-marchands — enregistrements versionnés, consommés en FIFO depuis le crédit le plus ancien non expiré.",
    "loading": "Chargement de la liste des crédits…",
    "status": {
      "active": "Actif",
      "used": "Utilisé",
      "expired": "Expiré",
      "revoked": "Révoqué",
      "all": "Tous"
    },
    "expiry": {
      "any": "Tous",
      "withinDays": "≤ {{days}} jours"
    },
    "empty": {
      "title": "Aucun crédit inter-marchands.",
      "bodyBefore": "Ouvrez le détail d'un marchand puis allez dans l'onglet",
      "tabName": "Crédit",
      "bodyAfter": "pour accorder / modifier / révoquer le crédit de ce marchand."
    },
    "errors": {
      "loadFailed": "Échec du chargement de la liste des crédits"
    },
    "revoke": {
      "successTitle": "Crédit révoqué",
      "successDesc": "L'historique a été mis à jour.",
      "reasonRequired": "Motif requis — de 10 à 500 caractères.",
      "failedTitle": "Échec de la révocation du crédit",
      "dialogTitle": "Révoquer le crédit",
      "merchantLabel": "Marchand :",
      "warning": "Version actuelle : v{{version}}. Le crédit déjà utilisé reste dû — le marchand doit payer le montant déjà utilisé. Cette action est irréversible.",
      "reasonLabel": "Motif de révocation (10–500 caractères)",
      "charsNeeded": "{{count}} caractères supplémentaires requis",
      "lengthOk": "Longueur suffisante",
      "cancel": "Annuler",
      "submitting": "Révocation…",
      "submit": "Révoquer"
    }
  },
  "gateway": {
    "title": "Passerelles de paiement",
    "subtitle": "Configuration et routage",
    "columns": {
      "name": "Passerelle",
      "type": "Type",
      "isActive": "Active",
      "priority": "Priorité"
    },
    "actions": {
      "configure": "Configurer",
      "enable": "Activer",
      "disable": "Désactiver",
      "testConnection": "Tester la connexion"
    },
    "errors": {
      "testFailed": "Échec du test de connexion",
      "missingCredentials": "Identifiants de passerelle non configurés"
    },
    "surfaces": {
      "ariaLabel": "Surfaces de passerelle",
      "tabP8": "Passerelles de paiement",
      "tabP3": "Configuration des passerelles (9 fournisseurs)"
    },
    "settings": {
      "toast": {
        "savedTitle": "Configuration de la passerelle enregistrée",
        "saveFailedTitle": "Impossible d'enregistrer la configuration",
        "webhookRegeneratedTitle": "Secret du webhook régénéré",
        "webhookRegeneratedDesc": "Mettez à jour le nouveau secret dans le tableau de bord de la passerelle pour que les webhooks continuent à être vérifiés.",
        "webhookRegenerateFailedTitle": "Impossible de régénérer le webhook",
        "webhookCopiedTitle": "URL du webhook copiée"
      },
      "loading": "Chargement de la configuration {{gateway}}…",
      "loadFailedPrefix": "Chargement impossible :",
      "tierLockedTier1": "Passerelle de niveau 1 — hot-swap non pris en charge.",
      "tierLockedTier2": "Passerelle de niveau 2 — hot-swap non pris en charge.",
      "savingShort": "Enregistrement…",
      "save": "Enregistrer",
      "networkError": "Erreur réseau — vérifiez la connexion",
      "pauseDialog": {
        "titlePause": "Mettre en pause la passerelle {{gateway}} ?",
        "titleResume": "Réactiver la passerelle {{gateway}} ?",
        "descPause": "La file BullMQ sera mise en pause et le portail marchand affichera le badge « Maintenance ». Une raison (≥{{min}} caractères) est requise pour l'audit log.",
        "descResume": "La file BullMQ reprendra automatiquement. Notes facultatives.",
        "reasonLabelPause": "Raison (≥{{min}} caractères)",
        "reasonLabelResume": "Notes (facultatif)",
        "reasonPlaceholderPause": "ex. Suspicion de pic de fraude — investigation en cours",
        "reasonPlaceholderResume": "ex. Le health check est stable depuis 5 minutes",
        "reasonTooShort": "La raison doit comporter au moins {{min}} caractères (actuellement {{count}}).",
        "cancel": "Annuler",
        "processing": "Traitement…",
        "confirmPause": "Mettre en pause",
        "confirmResume": "Réactiver"
      },
      "pauseBanner": "File en pause — le portail marchand affiche le badge « Maintenance ». Aucun basculement automatique vers une autre passerelle.",
      "card": {
        "auditNotice": "Chaque révélation est enregistrée dans l'audit log et masquée automatiquement après 30 s.",
        "statusHeading": "Statut",
        "pause": "Mettre en pause",
        "resume": "Réactiver",
        "apiKey": "Clé API",
        "reveal": "Révéler",
        "statusLabel": "Statut",
        "autoApprove": "Approbation auto",
        "yes": "Oui",
        "no": "Non",
        "lastHealthCheck": "Dernier health check"
      },
      "toastP8": {
        "pausedTitle": "{{gateway}} mise en pause",
        "resumedTitle": "{{gateway}} réactivée",
        "networkError": "Erreur réseau — vérifiez votre connexion.",
        "alreadyPausedTitle": "Passerelle déjà en pause",
        "pauseFailedTitle": "Impossible de mettre en pause",
        "notPausedTitle": "La passerelle n'est pas en pause",
        "resumeFailedTitle": "Impossible de réactiver"
      },
      "panel": {
        "statusFilterLabel": "Statut",
        "statusFilterAll": "Tous",
        "loadingList": "Chargement de la liste des passerelles…",
        "loadFailedPrefix": "Chargement impossible :",
        "loadFailedUnknown": "erreur inconnue",
        "empty": "Aucune passerelle de paiement dans ce statut.",
        "heading": "Passerelles de paiement",
        "subtitle": "Configuration globale des passerelles — identifiants masqués, mode de frais, pause/réactivation, health poll 60 s.",
        "statusEnabled": "Activée",
        "statusPaused": "En pause",
        "statusDisabled": "Désactivée"
      },
      "test": {
        "healthyTitle": "En bonne santé",
        "failedTitle": "Test échoué",
        "nonOk": "La passerelle a renvoyé une réponse non-OK",
        "connFailedTitle": "Échec du test de connexion",
        "testing": "Test en cours…",
        "testConnection": "Tester la connexion"
      },
      "health": {
        "untestedTitle": "Pas encore de health check en direct — cliquez sur Tester la connexion pour pinger cette passerelle.",
        "untested": "Non testée",
        "healthy": "En bonne santé",
        "degraded": "Dégradée",
        "down": "Hors service"
      },
      "legacy": {
        "heading": "Paramètres de passerelle (9 plugins hérités)",
        "subtitle": "Par passerelle : activation, mode de niveau, identifiants, health check"
      },
      "fields": {
        "enabled": "Activée",
        "tierMode": "Mode de niveau"
      },
      "tierOption": {
        "instant": "Instantané (Niveau 1{{lockSuffix}})",
        "manual": "Manuel + IMAP (Niveau 2{{lockSuffix}})",
        "lockedSuffix": " — verrouillé"
      },
      "credentials": {
        "heading": "Identifiants (chiffrés)",
        "placeholder": "Saisir l'identifiant",
        "fields": {
          "clientId": "ID client",
          "clientSecret": "Secret client",
          "publishableKey": "Clé publiable",
          "secretKey": "Clé secrète",
          "webhookSecret": "Secret webhook",
          "apiKey": "Clé API",
          "partnerId": "ID partenaire",
          "merchantId": "ID marchand",
          "apiKeyOptional": "Clé API (facultatif)"
        }
      },
      "webhook": {
        "heading": "URL du webhook",
        "copy": "Copier",
        "regenerate": "Régénérer"
      },
      "imapPreview": {
        "heading": "Aperçu du motif IMAP",
        "sender": "Expéditeur",
        "txnId": "ID transaction",
        "amount": "Montant",
        "editLink": "Modifier dans IMAP Config →"
      },
      "recentTx": {
        "heading": "Transactions récentes",
        "empty": "Aucune transaction récente",
        "colTxId": "ID transaction",
        "colAmount": "Montant",
        "colStatus": "Statut",
        "colDate": "Date"
      },
      "regenConfirm": {
        "title": "Régénérer le secret du webhook ?",
        "desc": "Les intégrations existantes utilisant l'ancien secret échoueront jusqu'à leur mise à jour. Cette action est irréversible.",
        "confirm": "Régénérer"
      },
      "p8health": {
        "lastCheck": "Dernier health check {{at}}",
        "noProbe": "Pas encore de sonde",
        "maintenance": "Maintenance (en pause)",
        "healthy": "En bonne santé",
        "degraded": "Dégradée",
        "down": "Hors service"
      }
    },
    "feeForm": {
      "heading": "Configuration des frais — {{gateway}}",
      "subtitle": "Le vendeur prend en charge les frais de passerelle. Chaque changement nécessite une raison pour l'audit log.",
      "modeLabel": "Modèle de frais",
      "mode": {
        "flat": "Fixe — frais fixe ($X)",
        "percent": "Pourcentage — pourcentage (Y%)",
        "combined": "Combiné — $X + Y%"
      },
      "flatLabel": "Frais fixe (USD)",
      "percentLabel": "Frais en pourcentage (%)",
      "previewLabel": "Frais appliqué :",
      "reasonLabel": "Raison du changement",
      "reasonPlaceholder": "ex. Ajusté selon le contrat vendeur T2",
      "saving": "Enregistrement…",
      "submit": "Enregistrer la configuration des frais",
      "toast": {
        "updatedTitle": "Configuration des frais mise à jour",
        "auditLog": "Audit log : {{id}}",
        "saveFailedTitle": "Impossible d'enregistrer la configuration des frais",
        "networkError": "Erreur réseau — vérifiez la connexion."
      },
      "errors": {
        "reasonMin": "La raison du changement doit comporter ≥ 5 caractères",
        "flatMin": "Le frais fixe doit être ≥ 0,00 $",
        "percentRange": "Le frais en pourcentage doit être entre 0 % et 100 %",
        "combinedBoth": "Le mode combiné nécessite fixe et pourcentage > 0",
        "flatRequired": "Le mode fixe nécessite un frais > 0,00 $",
        "percentRequired": "Le mode pourcentage nécessite un frais > 0 %"
      }
    },
    "reveal": {
      "ariaLabel": "Révéler la clé API — {{gateway}}",
      "title": "Révéler la clé API — {{gateway}}",
      "subtitle": "Chaque révélation est enregistrée dans l'audit log. La clé se masque automatiquement après {{seconds}} secondes.",
      "passwordLabel": "Votre mot de passe",
      "passwordPlaceholder": "Au moins 8 caractères",
      "cancel": "Annuler",
      "verifying": "Vérification…",
      "submit": "Révéler",
      "autoHidePrefix": "Masquage auto dans",
      "autoHideSuffix": ". Audit log enregistré.",
      "apiKeyLabel": "Clé API",
      "copy": "Copier",
      "hideNow": "Masquer maintenant",
      "toast": {
        "maskedTitle": "Clé API masquée",
        "maskedDesc": "La clé API a été masquée automatiquement après la fenêtre de consultation.",
        "revealedTitle": "Clé API révélée",
        "revealedDesc": "La clé se masquera automatiquement après {{seconds}} s — audit enregistré.",
        "rateLimitedTitle": "Trop de tentatives",
        "rateLimitedDesc": "Veuillez attendre quelques minutes et réessayer.",
        "revealFailedTitle": "Impossible de révéler la clé API",
        "networkError": "Erreur réseau — vérifiez la connexion.",
        "copied": "Clé API copiée"
      },
      "errors": {
        "passwordInvalid": "Le mot de passe de confirmation est incorrect"
      }
    }
  },
  "payout": {
    "title": "Paiements vendeurs",
    "subtitle": "File de paiements vendeurs",
    "columns": {
      "vendor": "Vendeur",
      "amount": "Montant",
      "period": "Période",
      "method": "Méthode",
      "status": "Statut"
    },
    "status": {
      "pending": "En attente",
      "processing": "En cours",
      "paid": "Payé",
      "failed": "Échoué",
      "cancelled": "Annulé"
    },
    "actions": {
      "process": "Traiter",
      "retry": "Réessayer",
      "cancel": "Annuler"
    },
    "withdraw": {
      "relative": {
        "justNow": "à l'instant",
        "minutes": "il y a {{count}} min",
        "hours": "il y a {{count}} h",
        "days": "il y a {{count}} j"
      },
      "tab": {
        "all": "Tout",
        "pending": "En attente",
        "approved": "Approuvé",
        "rejected": "Rejeté"
      },
      "status": {
        "pending": "En attente",
        "approved": "Approuvé",
        "rejected": "Rejeté",
        "cancelled": "Annulé"
      },
      "raceLoser": {
        "title": "Déjà traité par un autre admin",
        "description": "Cette demande a déjà été approuvée ou rejetée — la liste va se recharger.",
        "descriptionShort": "Cette demande a déjà été approuvée ou rejetée."
      },
      "networkErrorTitle": "Erreur réseau",
      "checkConnection": "Vérifiez la connexion",
      "loadFailed": "Échec du chargement de la file de retraits",
      "page": {
        "title": "Retraits marchands",
        "subtitle": "Approuvez ou rejetez les demandes de retrait des marchands (les paiements vendeurs sont dans Paiements vendeurs)"
      },
      "filterAria": "Filtre par statut de retrait",
      "column": {
        "merchant": "Marchand",
        "amount": "Montant",
        "bankAccount": "Compte bancaire",
        "date": "Date",
        "actions": "Actions"
      },
      "loading": "Chargement…",
      "emptyPending": "Aucune demande de retrait en attente",
      "emptyAll": "Aucune demande trouvée",
      "emptyStatus": "Aucune demande {{status}} trouvée",
      "cancel": "Annuler",
      "view": "Voir",
      "close": "Fermer",
      "field": {
        "amount": "Montant",
        "bankAccount": "Compte bancaire"
      },
      "internalNoteLabel": "Note interne (facultatif)",
      "approve": {
        "refRequired": "La référence du virement bancaire est requise",
        "refTooLong": "Référence trop longue (max {{max}} caractères)",
        "ledgerMissingTitle": "Approbation impossible — registre manquant",
        "ledgerMissingDesc": "Cet enregistrement en attente n'a pas d'écriture de blocage correspondante (données erronées). Contactez les ops pour re-seed ou annuler.",
        "failed": "Échec de l'approbation",
        "successTitle": "Retrait approuvé",
        "title": "Approuver le retrait — {{merchant}}",
        "refLabel": "Référence du virement bancaire",
        "refPlaceholder": "ex. WF-WIRE-20260429-7788",
        "refHelp": "Requis — collez l'ID bancaire/wire externe après l'envoi du virement (piste d'audit).",
        "internalNotePlaceholder": "Virement envoyé via Wells Fargo…",
        "submitting": "Approbation…",
        "submit": "Approuver"
      },
      "reject": {
        "reasonMin": "Le motif est requis (min {{min}} caractères)",
        "reasonMax": "Motif trop long (max {{max}} caractères)",
        "failed": "Échec du rejet",
        "successTitle": "Retrait rejeté",
        "title": "Rejeter le retrait — {{merchant}}",
        "reasonLabel": "Motif",
        "reasonHelp": "Visible par le marchand. 3 à 500 caractères.",
        "internalNotePlaceholder": "Marchand invité à fournir un SWIFT à jour…",
        "submitting": "Rejet…",
        "submit": "Rejeter"
      },
      "detail": {
        "title": "Demande de retrait — {{merchant}}",
        "merchant": "Marchand",
        "amount": "Montant",
        "bankAccount": "Compte bancaire",
        "status": "Statut",
        "requested": "Demandé le",
        "approved": "Approuvé le",
        "wireRef": "Réf. wire",
        "rejectReason": "Motif du rejet"
      }
    },
    "markTransferred": {
      "ariaLabel": "Marquer comme transféré — {{vendor}}",
      "title": "Marquer comme transféré — {{vendor}}",
      "subtitleBefore": "Le paiement passera au statut ",
      "completedLabel": "Completed",
      "subtitleAfter": ". Cette action est enregistrée dans le journal d'audit.",
      "invalidFormat": "Format invalide. Seuls les PDF, JPG ou PNG sont acceptés.",
      "fileTooLarge": "Le fichier dépasse la limite de 5 Mo (actuellement {{size}} Mo).",
      "refTooShort": "Une référence de virement est requise (minimum {{min}} caractères).",
      "refTooLong": "La référence de virement est trop longue (maximum {{max}} caractères).",
      "refRequired": "Une référence de virement est requise",
      "uploadFailed": "Échec de l'envoi du justificatif. Vous pouvez retirer la pièce jointe et réessayer, ou contacter ops.",
      "clearFile": "Retirer",
      "cancel": "Annuler",
      "submit": "Marquer Completed",
      "submitting": "Traitement…",
      "fields": {
        "netAmount": "Montant (net)",
        "vendor": "Fournisseur",
        "transferRef": "Référence de virement",
        "transferRefPlaceholder": "ex. WIRE-20260517-0042",
        "transferRefHelp": "Requis — collez la confirmation wire / SWIFT après le virement.",
        "proof": "Justificatif de relevé bancaire (optionnel)",
        "proofHelp": "PDF, JPG ou PNG. 5 Mo max. Le fichier est stocké et son lien apparaît dans les détails du paiement.",
        "notes": "Notes (optionnel)",
        "notesPlaceholder": "ex. Confirmé sur le portail bancaire à 14h32."
      },
      "toast": {
        "successTitle": "Marqué comme Transféré",
        "successDesc": "Paiement {{vendor}} ({{amount}}) passé à Completed.",
        "staleTitle": "Statut du paiement modifié",
        "staleDesc": "Le paiement n'est plus en Processing — la liste va se recharger.",
        "failTitle": "Impossible de marquer comme Transféré",
        "networkErrorTitle": "Erreur réseau",
        "networkErrorDesc": "Vérifiez votre connexion et réessayez."
      }
    },
    "errors": {
      "network": "Erreur réseau — vérifiez la connexion",
      "unknown": "Erreur inconnue"
    }
  },
  "transaction": {
    "title": "Transactions",
    "subtitle": "Registre des transactions inter-marchands",
    "columns": {
      "id": "ID transaction",
      "merchant": "Marchand",
      "type": "Type",
      "amount": "Montant",
      "gateway": "Passerelle",
      "createdAt": "Créée le",
      "status": "Statut",
      "direction": "Sens",
      "merchantVendor": "Marchand / Vendeur",
      "description": "Description"
    },
    "type": {
      "topup": "Recharge",
      "charge": "Débit",
      "refund": "Remboursement",
      "adjustment": "Ajustement",
      "withdrawal": "Retrait",
      "topup_credit": "Crédit de recharge",
      "order_charge": "Débit de commande",
      "refund_debit": "Débit de remboursement",
      "credit_grant": "Octroi de crédit",
      "credit_use": "Utilisation de crédit",
      "payout_debit": "Débit de paiement",
      "gateway_fee": "Frais de passerelle",
      "manual_adjustment": "Ajustement manuel",
      "invoice_payment": "Paiement de facture",
      "credit_memo_apply": "Application de note de crédit",
      "pre_payment": "Prépaiement",
      "transfer_in": "Transfert entrant",
      "transfer_out": "Transfert sortant",
      "chargeback": "Rétrofacturation"
    },
    "status": {
      "succeeded": "Réussie",
      "pending": "En attente",
      "failed": "Échouée",
      "reversed": "Annulée",
      "completed": "Terminée"
    },
    "filters": {
      "type": "Type",
      "gateway": "Passerelle",
      "dateFrom": "Du",
      "dateTo": "Au",
      "amountMin": "Montant min",
      "amountMax": "Montant max",
      "merchant": "Marchand",
      "allMerchants": "Tous les marchands",
      "vendor": "Vendeur",
      "allVendors": "Tous les vendeurs",
      "status": "Statut",
      "allStatuses": "Tous les statuts",
      "linkedOrderId": "ID de commande liée",
      "linkedOrderIdPlaceholder": "Collez un ID de commande",
      "linkedAdjustmentId": "ID d'ajustement / note de crédit liée",
      "linkedAdjustmentIdPlaceholder": "Collez un ID d'ajustement / note de crédit",
      "typeSelected": "Type de transaction ({{count}}/14 sélectionnés)",
      "clearTypes": "Effacer les types",
      "typeAria": "Filtre de type de transaction",
      "clearAll": "Effacer tous les filtres"
    },
    "page": {
      "description": "Registre inter-marchands / vendeurs. En lecture seule — chaque entrée provient de sa surface source (validation de recharge, remboursement, paiement, …)."
    },
    "toast": {
      "loadFailed": "Échec du chargement des transactions",
      "unknownError": "Erreur inconnue"
    },
    "summary": {
      "totalIn": "Total entrant",
      "totalOut": "Total sortant",
      "net": "Net",
      "pending": "En attente"
    },
    "loading": "Chargement…",
    "empty": "Aucune transaction ne correspond aux filtres actuels.",
    "savedViews": {
      "label": "Vues enregistrées :",
      "last24h": "Dernières 24 h",
      "clear": "Effacer la vue"
    },
    "search": {
      "label": "Rechercher",
      "placeholder": "id / description / marchand / vendeur"
    },
    "direction": {
      "in": "Entrée",
      "out": "Sortie"
    },
    "row": {
      "merchantLabel": "M :",
      "vendorLabel": "V :",
      "invoiceLabel": "facture :",
      "orderLabel": "commande :",
      "creditMemoLabel": "note de crédit :"
    },
    "detail": {
      "back": "Transactions",
      "title": "Détail de la transaction",
      "loading": "Chargement…",
      "notFound": "Transaction introuvable.",
      "directionIn": "Entrée d'argent",
      "directionOut": "Sortie d'argent",
      "order": "Commande",
      "invoice": "Facture",
      "time": "Horodatage",
      "linesHeading": "Écritures comptables (partie double)",
      "account": "Compte"
    }
  },
  "merchant_billing": {
    "title": "Facturation marchand",
    "subtitle": "Configuration de facturation par marchand",
    "tabs": {
      "config": "Configuration",
      "invoices": "Factures",
      "credits": "Crédits",
      "history": "Historique"
    },
    "fields": {
      "billingMode": "Mode de facturation",
      "currency": "Devise",
      "withdrawEnabled": "Retrait activé",
      "creditLimit": "Limite de crédit",
      "paymentTerms": "Délai de paiement (jours)",
      "legalEntity": "Entité légale"
    },
    "actions": {
      "save": "Enregistrer",
      "reset": "Réinitialiser"
    },
    "loading": "Chargement…",
    "merchantWithId": "Marchand {{id}}",
    "viewAllInvoices": "Voir toutes les factures",
    "errors": {
      "generic": "Une erreur s'est produite",
      "loadConfigFailed": "Échec du chargement de la configuration de facturation",
      "networkErrorTitle": "Erreur réseau",
      "networkError": "Erreur réseau - vérifiez la connexion",
      "loadInvoicesFailed": "Échec du chargement de l'historique des factures",
      "missingMerchantId": "ID marchand manquant dans l'URL."
    },
    "mode": {
      "heading": "Mode de facturation",
      "subheading": "Basculez entre PREPAID, CREDIT et INVOICE.",
      "quickSwitchLabel": "Mode de facturation (changement rapide)",
      "selectPlaceholder": "Sélectionner un mode…",
      "creditHint": "Utilisez les options complètes ci-dessous pour choisir le mode CREDIT.",
      "ariaLabel": "Mode de facturation",
      "walletFreezeWarning": "Le portefeuille sera gelé lors du passage au mode INVOICE. Le solde existant reste sous séquestre jusqu'au remboursement.",
      "reasonLabel": "Motif (journal d'audit)",
      "reasonPlaceholder": "Pourquoi changez-vous de mode ?",
      "adminOnly": "Admin uniquement",
      "switching": "Changement…",
      "saveBtn": "Enregistrer le mode",
      "switchFailed": "Échec du changement de mode",
      "versionStaleTitle": "Version de mode obsolète",
      "updatedTitle": "Mode de facturation mis à jour",
      "updatedDesc": "Basculé vers {{mode}}"
    },
    "modeOption": {
      "PREPAID": {
        "label": "Prépayé (portefeuille)",
        "description": "Le marchand recharge un solde de portefeuille à l'avance. Aucune facture émise."
      },
      "CREDIT": {
        "label": "Crédit (recharge auto)",
        "description": "Portefeuille rechargé automatiquement depuis la passerelle enregistrée. Échec de recharge → suspension."
      },
      "INVOICE": {
        "label": "Facture (conditions NET)",
        "description": "Factures périodiques générées par cycle. Le marchand paie NET-N jours après émission."
      }
    },
    "cycle": {
      "WEEKLY": "Hebdomadaire",
      "BIWEEKLY": "Bimensuel",
      "MONTHLY": "Mensuel"
    },
    "paymentMethod": {
      "BANK_TRANSFER": "Virement bancaire",
      "GATEWAY": "Passerelle de paiement"
    },
    "invoiceStatus": {
      "DRAFT": "Brouillon",
      "SENT": "Envoyée",
      "PENDING_APPROVAL": "En attente",
      "PAID": "Payée",
      "PARTIAL": "Partielle",
      "OVERDUE": "En retard",
      "VOIDED": "Annulée"
    },
    "outstanding": {
      "heading": "Encours",
      "subheading": "Encours brut et net (plafond souple).",
      "gross": "Encours brut",
      "net": "Encours net",
      "netHint": "Après application des notes de crédit actives",
      "softLimit": "Plafond souple",
      "overCap": "Plafond souple dépassé — les commandes peuvent être bloquées",
      "noSoftLimit": "Aucun plafond souple configuré."
    },
    "config": {
      "heading": "Configuration de facturation",
      "subheading": "Cycle, jours d'échéance, limite de crédit et modes de paiement. S'applique aux marchands en mode INVOICE.",
      "invoiceOnly": "La configuration de facturation ne s'applique qu'aux marchands en mode INVOICE. Changez d'abord de mode.",
      "cycleLabel": "Cycle",
      "dueDaysLabel": "Jours d'échéance (1–90)",
      "dueDayTypeLabel": "Type de jour d'échéance",
      "dueDayTypeHelp": "Jours ouvrés = ignorer samedi/dimanche. Recommandé pour le B2B selon la norme du secteur.",
      "businessDays": "Jours ouvrés",
      "businessDaysHint": "(recommandé — ignorer week-ends + jours fériés de l'entité)",
      "calendarDays": "Jours calendaires",
      "calendarDaysHint": "(addition de dates simple)",
      "softLimitLabel": "Plafond souple / Limite de crédit (USD, facultatif)",
      "softLimitPlaceholder": "ex. 50000",
      "paymentMethodsLabel": "Modes de paiement",
      "withdrawLabel": "Autorisation de retrait",
      "withdrawManageTip": "Gérer dans l'onglet Portefeuille",
      "withdrawEnterpriseTip": "Le retrait est réservé au niveau Enterprise",
      "withdrawDesc": "Autoriser le marchand à retirer le solde du portefeuille",
      "withdrawTierHint": "— niveau Enterprise uniquement (actuel : {{tier}})",
      "saving": "Enregistrement…",
      "saveBtn": "Enregistrer la config",
      "validationFailed": "Échec de la validation",
      "saveFailed": "Échec de l'enregistrement de la configuration de facturation",
      "savedTitle": "Configuration de facturation enregistrée",
      "savedDesc": "Mise à jour pour {{name}}",
      "merchantFallback": "marchand",
      "errors": {
        "dueDays": "Les jours d'échéance doivent être compris entre 1 et 90",
        "paymentMethods": "Choisissez au moins un mode de paiement",
        "softLimit": "Le plafond souple doit être un nombre non négatif"
      }
    },
    "invoices": {
      "heading": "Factures récentes",
      "subheading": "Factures passées de ce marchand. Voir tout dans la page Factures inter-marchands.",
      "viewAll": "Voir tout",
      "columns": {
        "number": "N° facture",
        "period": "Période",
        "amount": "Montant",
        "status": "Statut",
        "due": "Échéance",
        "actions": "Actions"
      },
      "loading": "Chargement des factures…",
      "empty": "Aucune facture trouvée pour ce marchand",
      "view": "Voir"
    },
    "settlement": {
      "title": "Régler l'encours avant le changement de mode",
      "outstandingGross": "Encours (brut)",
      "creditsAvailable": "Notes de crédit actives disponibles",
      "activeMemos": "Notes de crédit actives ({{count}})",
      "convertTitle": "Régler maintenant — convertir les notes de crédit → portefeuille",
      "convertDesc": "Transférez {{amount}} des notes de crédit vers le portefeuille du marchand, puis changez de mode.",
      "carryTitle": "Reporter — appliquer les crédits → encours, puis changer",
      "carryDesc": "Appliquez d'abord {{amount}} aux factures en cours, puis changez de mode.",
      "insufficientInline": "Il reste {{amount}} d'encours — choisissez une autre option ou payez le reste d'abord.",
      "refundTitle": "Rembourser les notes de crédit sur le compte bancaire",
      "refundDesc": "Ouvrez une demande de remboursement ({{amount}}) pour que la finance vire vers la banque du marchand, puis changez de mode.",
      "cancelTitle": "Annuler — garder le mode actuel",
      "cancelDesc": "Ne pas changer. Réglez l'encours manuellement d'abord.",
      "close": "Fermer",
      "confirm": "Confirmer le passage vers {{mode}}",
      "insufficientTitle": "Notes de crédit insuffisantes",
      "insufficientDesc": "Il reste {{amount}} d'encours après application des crédits — choisissez une autre option de règlement.",
      "requiredTitle": "Règlement requis"
    }
  },
  "manual_generate": {
    "backToInvoices": "Retour aux factures",
    "heading": "Générer une facture manuelle",
    "subtitlePrefix": "Remplacez la génération automatique par cycle pour des charges ad hoc ou des corrections. Les factures manuelles sont numérotées",
    "subtitleSuffix": ".",
    "steps": {
      "compose": "Composer",
      "preview": "Aperçu et confirmation"
    },
    "merchantLabel": "Marchand",
    "merchantPlaceholder": "Sélectionnez un marchand en mode INVOICE…",
    "merchantHintPrefix": "Seuls les marchands en mode de facturation INVOICE sont listés (filtre serveur",
    "merchantHintSuffix": ").",
    "merchantInfo": {
      "title": "Infos marchand",
      "name": "Nom :",
      "phone": "Téléphone :",
      "email": "Email :",
      "businessName": "Raison sociale :",
      "taxId": "N° fiscal :",
      "address": "Adresse :"
    },
    "storeLabel": "Boutique",
    "storeAll": "— Toutes les boutiques —",
    "gatewayLabel": "Passerelle de paiement",
    "gatewayAll": "— Toutes les passerelles —",
    "cycleStartLabel": "Début de la fenêtre de cycle",
    "cycleEndLabel": "Fin de la fenêtre de cycle",
    "rangeHint": "Plage : {{days}} jours (max {{max}})",
    "taxLabel": "Montant de taxe personnalisé (USD, optionnel)",
    "taxPlaceholder": "ex. 12.50",
    "taxHint": "Laissez vide pour un calcul automatique. Le moteur de taxe est reporté à une phase ultérieure ; une saisie manuelle est autorisée pour les factures B2B.",
    "markupLabel": "Majoration du prix unitaire (%)",
    "markupPlaceholder": "ex. 5.0",
    "markupHint": "Appliquée au prix unitaire de chaque ligne avant taxe.",
    "legalEntityLabel": "Entité légale",
    "legalEntityDefault": "— Par défaut —",
    "legalEntityDefaultSuffix": " — par défaut",
    "timezoneLabel": "Fuseau horaire",
    "notesLabel": "Note interne (admin uniquement)",
    "notesPlaceholder": "Motif de la génération manuelle…",
    "notesCount": "{{count}}/500",
    "cancel": "Annuler",
    "preview": "Aperçu",
    "previewPanel": {
      "numberingPreview": "Aperçu de la numérotation :",
      "merchant": "Marchand",
      "billingMode": "Mode de facturation",
      "cycleWindow": "Fenêtre de cycle",
      "cycleDays": "({{days}} j)",
      "tax": "Taxe",
      "internalNote": "Note interne",
      "workerNotice": "Le worker peut prendre quelques secondes. Le sous-total et le total final sont agrégés par le worker de génération de facture du backend ; cet aperçu reflète ce que vous avez saisi, pas les totaux calculés."
    },
    "backToEdit": "Retour à l'édition",
    "generating": "Génération…",
    "confirmGenerate": "Confirmer et générer",
    "taxAuto": "Auto (calculé par le worker — reporté à une phase ultérieure)",
    "taxManual": "{{amount}} (saisie manuelle)",
    "errors": {
      "cycleEndOrder": "La fin du cycle doit être à la même date ou après le début du cycle.",
      "rangeMax": "La plage de dates doit être ≤ {{max}} jours (actuellement {{days}} j).",
      "taxInvalid": "Le montant de taxe doit être un nombre non négatif avec au plus 2 décimales.",
      "completeBeforePreview": "Veuillez compléter le marchand et la fenêtre de cycle avant l'aperçu.",
      "formInvalid": "Le formulaire est invalide.",
      "noTransactions": "Aucune commande dans cette période — la facture serait vide. Changez la période ou attendez que le marchand génère des commandes."
    },
    "toast": {
      "noTransactionsTitle": "Aucune donnée dans la période",
      "failTitle": "Échec de la génération de la facture",
      "successTitle": "Génération de facture mise en file · {{number}}",
      "successDesc": "Marchand {{merchant}} — période {{from}} → {{to}}. La nouvelle facture apparaîtra dans la liste une fois le worker terminé.",
      "networkTitle": "Erreur réseau"
    }
  },
  "fraud": {
    "page": {
      "heading": "Paramètres anti-fraude",
      "subtitle": "Limites de vélocité, règles de recharge suspecte, périodes de refroidissement"
    },
    "loading": "Chargement de la configuration…",
    "loadFailedPrefix": "Impossible de charger la configuration :",
    "unknown": "inconnu",
    "velocity": {
      "heading": "Limites de vélocité",
      "maxWithdraw": "Retraits max / jour par marchand",
      "maxWithdrawHint": "Montant USD maximum retiré par jour (dollars entiers)",
      "maxTopup": "Demandes de recharge max / jour par marchand"
    },
    "suspicious": {
      "heading": "Indicateur de recharge suspecte",
      "countThreshold": "Seuil du nombre en attente",
      "amountThreshold": "Seuil du montant total (USD)"
    },
    "cooling": {
      "heading": "Période de refroidissement",
      "defaultDays": "Jours de refroidissement par défaut après approbation du retrait",
      "defaultDaysHint": "Mettre 0 pour désactiver le refroidissement globalement"
    },
    "overrides": {
      "heading": "Substitutions par marchand",
      "description": "Trouvez un marchand par nom / email → personnalisez vélocité / refroidissement indépendamment du défaut global. Les substitutions priment sur la valeur globale.",
      "merchantPlaceholder": "Sélectionner un marchand…",
      "open": "Ouvrir les substitutions",
      "merchantLabel": "Marchand :",
      "loading": "Chargement de la substitution…",
      "maxTopup": "Demandes de recharge max / jour (substitution, laisser vide = hériter)",
      "maxWithdraw": "Retrait max / jour USD (substitution)",
      "coolingDays": "Substitution de la période de refroidissement (jours, 0 = désactiver)",
      "cancel": "Annuler",
      "saving": "Enregistrement…",
      "save": "Enregistrer la substitution"
    },
    "discard": "Annuler",
    "saving": "Enregistrement…",
    "saveChanges": "Enregistrer les modifications",
    "toast": {
      "savedTitle": "Configuration anti-fraude enregistrée",
      "saveFailedTitle": "Impossible d'enregistrer la configuration",
      "networkError": "Erreur réseau — vérifiez la connexion",
      "overrideSavedTitle": "Substitution marchand enregistrée",
      "overrideFailedTitle": "Impossible d'enregistrer la substitution",
      "noMerchantTitle": "Aucun marchand sélectionné",
      "noMerchantDesc": "Veuillez sélectionner un marchand avant d'ouvrir les substitutions"
    }
  },
  "fx_rate": {
    "page": {
      "heading": "Taux de change",
      "subtitle": "Taux de change par passerelle (cliquez une cellule pour modifier). Périmé ≥{{days}} jours marqué en rouge."
    },
    "addCurrency": "+ Ajouter une devise",
    "failedToLoad": "Échec du chargement",
    "allowed": {
      "heading": "Devises autorisées",
      "description": "Codes ISO-4217 que les marchands sont autorisés à recharger. Ajoutez/retirez puis cliquez sur Enregistrer.",
      "saving": "Enregistrement…",
      "save": "Enregistrer",
      "loading": "Chargement…",
      "empty": "Aucune devise autorisée pour l'instant.",
      "removeAria": "Retirer {{code}}",
      "addLabel": "Ajouter un code ISO-4217",
      "add": "+ Ajouter",
      "unsavedHint": "Modifications non enregistrées — cliquez sur Enregistrer ci-dessus."
    },
    "table": {
      "loading": "Chargement des taux de change…",
      "empty": "Aucun taux de change configuré",
      "colCurrency": "Devise",
      "colLastUpdated": "Dernière mise à jour",
      "markStale": "Marquer périmé"
    },
    "confirm": {
      "markStale": "Marquer {{currency}} comme périmé ?"
    },
    "modal": {
      "title": "Ajouter une devise",
      "codeLabel": "Code ISO-4217 (ex. USD, EUR)",
      "gatewayLabel": "Passerelle",
      "gatewayPlaceholder": "paypal | stripe | sunrate | …",
      "rateLabel": "Taux initial (6 décimales, ex. 1.080000)",
      "cancel": "Annuler",
      "add": "Ajouter"
    },
    "age": {
      "today": "aujourd'hui",
      "oneDayAgo": "il y a 1 jour",
      "daysAgo": "il y a {{days}} jours",
      "daysStale": "{{days}} jours (périmé)"
    },
    "toast": {
      "isoInvalid": "Le code ISO-4217 doit comporter 3 lettres A-Z",
      "isoInvalidShort": "Le code ISO-4217 doit comporter 3 caractères",
      "alreadyInList": "{{code}} est déjà dans la liste",
      "allowedSaved": "Liste des devises autorisées enregistrée",
      "allowedSaveFailed": "Impossible d'enregistrer les devises autorisées",
      "networkError": "Erreur réseau — vérifiez la connexion",
      "rateSaved": "Taux enregistré",
      "rateSaveFailed": "Impossible d'enregistrer le taux",
      "markedStale": "Taux marqué comme périmé",
      "markStaleFailed": "Impossible de marquer comme périmé",
      "invalidRate": "Taux invalide",
      "invalidRateDesc": "Doit être un nombre positif (ex. 1.080000)",
      "gatewayRequired": "Une passerelle est requise"
    }
  },
  "imap": {
    "page": {
      "heading": "Configuration IMAP",
      "subtitle": "Analyseur d'emails bancaires — se connecte à la boîte de réception des reçus et extrait les détails de transaction"
    },
    "tabs": {
      "connection": "Connexion",
      "matrix": "Analyseurs par passerelle",
      "logs": "Journaux"
    },
    "connection": {
      "heading": "Connexion",
      "host": "Hôte",
      "port": "Port",
      "secure": "Sécurisé (SSL/TLS)",
      "secureHint": "Utiliser SSL/TLS (chiffrer la connexion à la boîte mail)",
      "namespacePlaceholder": "ex. printway-bank-receipts",
      "namespaceHint": "Identifiant de source d'idempotence — le mot générique « imap » n'est pas autorisé.",
      "email": "Email",
      "password": "Mot de passe d'application (app password)",
      "passwordPlaceholder": "Saisir le mot de passe d'application",
      "pollInterval": "Intervalle de sondage (1–15 min)",
      "pollCurrent": "Actuellement : {{minutes}} minutes"
    },
    "fields": {
      "sourceNamespace": "Source namespace"
    },
    "parserTest": {
      "heading": "Test de l'analyseur",
      "gatewayLabel": "Analyseur de passerelle",
      "testing": "Test en cours…",
      "testButton": "Tester l'analyse",
      "samplePlaceholder": "Collez un email exemple ici...",
      "resultHeading": "Résultat de l'analyse",
      "matchYes": "Correspondance : oui",
      "txId": "ID transaction",
      "amount": "Montant",
      "none": "(aucun)",
      "wouldLinkLabel": "Lierait à la demande",
      "noMatchingRequest": "Aucune demande en attente correspondante",
      "matchNo": "Correspondance : non — les regex expéditeur/transaction/montant n'ont pas correspondu à cet exemple.",
      "runHint": "Lancez le test pour prévisualiser la sortie de l'analyseur"
    },
    "matrix": {
      "heading": "Matrice de regex par passerelle",
      "description": "Chaque passerelle de niveau 2 a besoin de 3 regex : filtre expéditeur, extracteur d'ID transaction, extracteur de montant.",
      "colGateway": "Passerelle",
      "colSender": "Regex expéditeur",
      "colTxnId": "Regex ID transaction",
      "colAmount": "Regex montant",
      "senderPlaceholder": "^noreply@...",
      "txnIdPlaceholder": "Transaction ID:\\\\s*([A-Z0-9-]+)",
      "amountPlaceholder": "Amount:\\\\s*\\\\$?([0-9,.]+)"
    },
    "logs": {
      "heading": "Historique d'analyse (100 derniers)",
      "loading": "Chargement des journaux…",
      "loadFailed": "Échec du chargement des journaux",
      "empty": "Aucune activité d'analyse pour l'instant.",
      "colDate": "Date",
      "colSender": "Expéditeur",
      "colGateway": "Passerelle",
      "colMatch": "Correspondance",
      "colTxId": "ID transaction",
      "colAmount": "Montant",
      "colLinked": "Lié",
      "yes": "oui",
      "no": "non"
    },
    "discard": "Annuler",
    "saving": "Enregistrement…",
    "save": "Enregistrer",
    "validation": {
      "nsRequired": "Le source namespace est requis",
      "nsFormat": "Doit commencer par une lettre ; seuls les lettres, chiffres, _ et - sont autorisés",
      "nsForbidden": "Le mot générique « imap » est interdit — choisissez un namespace plus spécifique",
      "invalidRegex": "Regex invalide sur {{gateway}}.{{field}} — veuillez corriger avant d'enregistrer"
    },
    "toast": {
      "savedTitle": "Configuration IMAP enregistrée",
      "saveFailedTitle": "Impossible d'enregistrer IMAP",
      "networkError": "Erreur réseau — vérifiez la connexion",
      "testParseFailedTitle": "Échec du test d'analyse"
    }
  },
  "chargeback": {
    "list": {
      "heading": "Rétrofacturations",
      "subtitle": "Surveillez les cas de rétrofacturation des marchands — progression du recouvrement et délais de 7 jours.",
      "loading": "Chargement…",
      "empty": "Aucun cas de rétrofacturation pour ce filtre.",
      "rowAria": "Ouvrir la rétrofacturation {{id}} de {{merchant}}",
      "colCaseId": "ID du cas",
      "colMerchant": "Marchand",
      "colGateway": "Passerelle",
      "colAmount": "Montant",
      "colStatus": "Statut",
      "colDeadline": "Échéance"
    },
    "filters": {
      "ariaLabel": "Filtre de statut des rétrofacturations",
      "all": "Tous les cas",
      "open": "Ouvert",
      "disputed": "Contesté",
      "resolved": "Résolu",
      "debt_outstanding": "Dette en cours"
    },
    "detail": {
      "back": "Retour aux rétrofacturations",
      "backToList": "Retour à la liste",
      "loading": "Chargement du cas…",
      "notFound": "Cas introuvable.",
      "casePrefix": "Cas",
      "subtitle": "{{gateway}} — débit initial {{amount}} — ouvert {{opened}}",
      "recoveryDeadline": "Échéance de recouvrement : {{value}}",
      "caseDetails": "Détails du cas",
      "gateway": "Passerelle",
      "chargebackId": "ID rétrofacturation",
      "reasonCode": "Code de motif",
      "originalCharge": "Débit initial",
      "merchant": "Marchand",
      "frozenAmount": "Montant gelé (frais inclus)",
      "recoveryProgress": "Progression du recouvrement",
      "debtRemaining": "Dette restante"
    },
    "timeline": {
      "heading": "Chronologie",
      "opened": "Rétrofacturation ouverte",
      "openedDetail": "{{ago}} · fonds gelés ({{amount}})",
      "eventDetail": "{{ago}} · {{id}}",
      "approaching": "Échéance de recouvrement approche",
      "approachingDetail": "dans {{time}} · {{debt}} restant",
      "passed": "Échéance de recouvrement dépassée",
      "passedDetail": "{{debt}} non recouvré"
    },
    "actions": {
      "heading": "Actions",
      "resolve": "Résoudre manuellement",
      "addNote": "Ajouter une note admin",
      "markLost": "Marquer comme perdu (passage en perte)",
      "note": "Le recouvrement s'effectue automatiquement quand le marchand recharge. La résolution manuelle est réservée au niveau admin."
    },
    "deadline": {
      "passed": "Échéance dépassée",
      "remaining": "{{time}} restant",
      "hoursOnly": "{{hours}} h",
      "daysHours": "{{days}} j {{hours}} h"
    },
    "timeAgo": {
      "dayAgo": "il y a {{count}} jour",
      "daysAgo": "il y a {{count}} jours",
      "hourAgo": "il y a {{count}} h",
      "hoursAgo": "il y a {{count}} h",
      "justNow": "à l'instant"
    },
    "status": {
      "open": "Ouvert",
      "investigating": "En investigation",
      "resolved_won": "Résolu (gagné)",
      "resolved_lost": "Résolu (perdu)",
      "disputed": "Contesté",
      "resolved": "Résolu",
      "debt_outstanding": "Dette en cours",
      "frozen_pending_recovery": "Gelé — en attente de recouvrement"
    },
    "outcome": {
      "won": "gagné",
      "resolved": "résolu",
      "lost": "perdu",
      "expired": "expiré"
    },
    "cancel": "Annuler",
    "toast": {
      "loadDetailFailed": "Échec du chargement de la rétrofacturation",
      "loadListFailed": "Échec du chargement des rétrofacturations",
      "networkError": "Erreur réseau",
      "checkConnection": "Vérifiez la connexion"
    },
    "resolve": {
      "title": "Résoudre la rétrofacturation manuellement",
      "outcomeLabel": "Résultat",
      "outcomeWon": "Gagné (litige inversé)",
      "outcomeResolved": "Résolu (recouvré)",
      "outcomeLost": "Perdu (passage en perte)",
      "outcomeExpired": "Expiré (échéance dépassée)",
      "terminalHint": "Statut terminal — le cas ne peut pas être rouvert depuis cette page.",
      "noteLabel": "Note (facultatif)",
      "notePlaceholder": "Note interne — contexte pour l'audit trail (max 500 caractères)",
      "submitting": "Résolution…",
      "submit": "Résoudre",
      "toast": {
        "failed": "Échec de la résolution",
        "success": "Rétrofacturation résolue",
        "successDesc": "Marqué comme {{outcome}}"
      }
    },
    "addNote": {
      "title": "Ajouter une note admin",
      "noteLabel": "Note",
      "notePlaceholder": "Contexte interne — échanges, conclusions d'investigation, etc. (max 500 caractères)",
      "hint": "Les notes sont en ajout seul et enregistrées avec votre id admin.",
      "submitting": "Enregistrement…",
      "submit": "Enregistrer la note",
      "toast": {
        "requiredTitle": "Note requise",
        "requiredDesc": "Veuillez saisir une note avant d'enregistrer.",
        "failed": "Échec de l'ajout de la note",
        "success": "Note ajoutée",
        "successDesc": "Note admin enregistrée dans l'audit trail"
      }
    },
    "markLost": {
      "title": "Marquer la rétrofacturation comme perdue ?",
      "irreversible": "Ceci est irréversible.",
      "bodyPrefix": "Le cas",
      "bodySuffix": "sera passé en perte. La dette en cours restera au grand livre et ce cas ne se recouvrira plus automatiquement à partir des recharges du marchand.",
      "submitting": "Marquage…",
      "confirm": "Confirmer — marquer comme perdu",
      "toast": {
        "failed": "Échec du marquage comme perdu",
        "success": "Rétrofacturation marquée comme perdue",
        "successDesc": "{{id}} passé en perte"
      }
    }
  },
  "merchant_picker": {
    "title": "Choisir un marchand",
    "searchPlaceholder": "Rechercher par nom, e-mail ou ID…",
    "loading": "Chargement…",
    "noResults": "Aucun marchand correspondant",
    "prompt": "Tapez pour rechercher un marchand par nom / e-mail / ID"
  },
  "errors": {
    "requestFailed": "Échec de la requête (HTTP {{status}})"
  },
  "whitelist": {
    "title": "Liste blanche",
    "subtitle": "Capacités par marchand, fermées par défaut jusqu'à ouverture par un administrateur.",
    "tab": {
      "merchants": "Marchands",
      "paymentMethods": "Moyens de paiement",
      "config": "Configuration",
      "log": "Journal"
    },
    "merchants": {
      "heading": "Liste blanche du paiement par carte",
      "hint": "Marchands autorisés à régler commandes et factures directement par carte enregistrée, sans passer par leur portefeuille. À ouvrir marchand par marchand depuis Détail marchand → Wallet & Billing.",
      "search": "Rechercher par nom ou e-mail",
      "colName": "Marchand",
      "colEmail": "E-mail",
      "colPerOrder": "Plafond par débit",
      "colPerDay": "Plafond quotidien",
      "noLimit": "Sans plafond",
      "empty": "Aucun marchand n'est encore autorisé au paiement par carte.",
      "loadError": "Impossible de charger la liste blanche.",
      "count": "{{count}} marchand(s)",
      "add": {
        "heading": "Ajouter un marchand",
        "hint": "Ouvre le paiement par carte pour ce marchand. Laisser un plafond vide signifie aucune limite.",
        "merchantLabel": "Marchand",
        "perOrderLabel": "Plafond par paiement ($)",
        "perDayLabel": "Plafond journalier ($)",
        "submit": "Ajouter à la liste",
        "submitting": "Ajout en cours…",
        "pickMerchant": "Choisissez d'abord un marchand.",
        "badAmount": "Saisissez un montant valide, ou laissez vide pour aucune limite.",
        "alreadyListed": "Ce marchand est déjà sur la liste.",
        "failed": "Impossible d'ajouter ce marchand.",
        "added": "Marchand ajouté à la liste.",
        "noLimitConfirm": "Je confirme : plafond vide = aucune limite",
        "noLimitRequired": "Un plafond vide signifie des dépenses par carte illimitées — cochez la case pour confirmer, ou saisissez un montant."
      },
      "picker": {
        "title": "Choisir un marchand",
        "searchPlaceholder": "Rechercher par nom, e-mail ou ID…",
        "loading": "Chargement…",
        "noResults": "Aucun marchand correspondant",
        "prompt": "Tapez pour rechercher par nom, e-mail ou ID"
      },
      "colActions": "Actions",
      "remove": {
        "cta": "Retirer",
        "confirmTitle": "Retirer de la liste ?",
        "confirmBody": "{{name}} perd immédiatement l'option de paiement par carte, sur tous les écrans de paiement. Les plafonds définis sont conservés : une réactivation ne repart donc pas sans limite.",
        "confirmCta": "Retirer",
        "done": "Marchand retiré de la liste.",
        "failed": "Impossible de retirer ce marchand."
      },
      "removing": "Retrait en cours…",
      "noPermission": "Vous n'avez pas la permission de modifier la liste."
    },
    "paymentMethods": {
      "heading": "Moyens ouverts aux marchands autorisés",
      "hint": "Seules les cartes Stripe peuvent être débitées directement aujourd'hui. PayPal n'a pas de flux d'enregistrement de compte.",
      "stripe": "Stripe (cartes enregistrées)",
      "stripeOn": "Disponible",
      "stripeOff": "Passerelle désactivée — activez-la d'abord dans Gateway Settings",
      "stripeUnknown": "Impossible de lire l'état de la passerelle — ce n'est pas une confirmation que Stripe est désactivé.",
      "paypal": "PayPal",
      "paypalUnsupported": "Non pris en charge — aucun flux de compte enregistré"
    },
    "config": {
      "heading": "Règles non modifiables par un administrateur",
      "invoiceRule": "Un marchand facturé peut régler une facture par carte, mais jamais une commande isolée — celle-ci serait refacturée sur sa prochaine facture.",
      "refundRule": "Un débit par carte ne peut pas être remboursé sur la carte depuis ici. Les remboursements vont au portefeuille du marchand.",
      "threeDsRule": "Les cartes exigeant 3-D Secure sont refusées — ce flux ne comporte aucune étape d'authentification en session.",
      "limitsHint": "Les plafonds par débit et quotidien se définissent par marchand. Laisser vide signifie sans plafond.",
      "fraudLink": "Paramètres anti-fraude"
    },
    "noAccess": "Vous n'avez pas la permission de consulter cette liste.",
    "log": {
      "heading": "Qui a changé quoi",
      "hint": "Chaque fois qu'un administrateur ouvre, ferme ou replafonne le paiement par carte d'un marchand.",
      "colTime": "Date",
      "colAdmin": "Administrateur",
      "colMerchant": "Marchand",
      "colChange": "Changement",
      "colLimits": "Plafonds après",
      "change": {
        "added": "Ajouté",
        "removed": "Retiré",
        "limits": "Plafonds modifiés"
      },
      "filter": {
        "from": "Du",
        "to": "Au"
      },
      "empty": "Aucun changement enregistré pour le moment.",
      "loadError": "Impossible de charger le journal.",
      "loadMore": "Charger plus",
      "unknownAdmin": "—",
      "noLimit": "Aucune limite",
      "legacyNote": "Les entrées enregistrées avant ce journal peuvent ne pas nommer l'administrateur."
    }
  }
}
